// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: feeds.proto

/* eslint-disable */
import { LinkoutTemplate, MoneyRange, QuantitativeValue, UriTemplate } from './common'
import { Duration } from './google/protobuf/duration'
import { DateMessage } from './google/type/date'
import { Money } from './google/type/money'

/** Feeds declaration */

/** Describes how a Price should be interpreted and displayed to the user. */
export enum PriceInterpretation {
	/** PRICE_INTERPRETATION_UNSPECIFIED - Price interpretation unspecified, defaults to EXACT_AMOUNT. */
	PRICE_INTERPRETATION_UNSPECIFIED = 'PRICE_INTERPRETATION_UNSPECIFIED',
	/**
	 * EXACT_AMOUNT - When the price should be interpreted as a specific value.
	 *
	 * Examples:
	 *   $20 for a yoga class; $15 for a child haircut
	 */
	EXACT_AMOUNT = 'EXACT_AMOUNT',
	/**
	 * STARTS_AT - When the price of a service is variable but a minimum price is known and
	 * displayed to consumers. Consumers may make choices which increase the
	 * price.
	 *
	 * Note that any service that uses this PriceInterpretation must use
	 * PrepaymentType NOT_SUPPORTED.
	 *
	 * Examples:
	 *   $30 for dog grooming, but additional consumer choices may increase the
	 *   price
	 */
	STARTS_AT = 'STARTS_AT',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/** Defines how a total price is determined from an availability. */
export enum PriceType {
	/**
	 * FIXED_RATE_DEFAULT - The price is for a fixed amount. This is the default value if the field is
	 * not set.
	 *
	 * Examples:
	 *   $50 deposit to reserve a table; $20 no show fee for a yoga class
	 */
	FIXED_RATE_DEFAULT = 'FIXED_RATE_DEFAULT',
	/**
	 * PER_PERSON - The price specified is per person, and the total price is calculated
	 * according to the party size specified in Resources as price_micros *
	 * party_size. A PER_PERSON price must be accompanied by a party size in the
	 * availability resources. If it is not, a party size of one is used.
	 *
	 * Examples:
	 *   $10 each for tickets to a museum
	 */
	PER_PERSON = 'PER_PERSON',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/** Defines whether a credit card is required in order to book an appointment. */
export enum RequireCreditCard {
	/**
	 * REQUIRE_CREDIT_CARD_UNSPECIFIED - The credit card requirement is not explicitly specified and the
	 * behaviour is identical to the one specified for CONDITIONAL.
	 */
	REQUIRE_CREDIT_CARD_UNSPECIFIED = 'REQUIRE_CREDIT_CARD_UNSPECIFIED',
	/**
	 * REQUIRE_CREDIT_CARD_CONDITIONAL - Google will require a credit card for the booking if any of the following
	 * conditions are met:
	 * * the availability has a price and the prepayment_type is REQUIRED
	 * * the no_show_fee is set
	 * * the deposit field is set.
	 */
	REQUIRE_CREDIT_CARD_CONDITIONAL = 'REQUIRE_CREDIT_CARD_CONDITIONAL',
	/**
	 * REQUIRE_CREDIT_CARD_ALWAYS - A credit card is always required in order to book this availability
	 * regardless of other field values.
	 */
	REQUIRE_CREDIT_CARD_ALWAYS = 'REQUIRE_CREDIT_CARD_ALWAYS',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/**
 * The platform that the action is performed on. Web application is the general
 * fallback. It is recommended to have at least one ActionLink with
 * ACTION_PLATFORM_WEB_APPLICATION. Links with Android and iOS as platform are
 * only used on the respective system.
 */
export enum ActionPlatform {
	/** ACTION_PLATFORM_UNSPECIFIED - The platform is unspecified. */
	ACTION_PLATFORM_UNSPECIFIED = 'ACTION_PLATFORM_UNSPECIFIED',
	/** ACTION_PLATFORM_WEB_APPLICATION - The action platform is web in general. */
	ACTION_PLATFORM_WEB_APPLICATION = 'ACTION_PLATFORM_WEB_APPLICATION',
	/** ACTION_PLATFORM_MOBILE_WEB - The action platform is web on mobile devices. */
	ACTION_PLATFORM_MOBILE_WEB = 'ACTION_PLATFORM_MOBILE_WEB',
	/** ACTION_PLATFORM_ANDROID - The action platform is Android OS. */
	ACTION_PLATFORM_ANDROID = 'ACTION_PLATFORM_ANDROID',
	/** ACTION_PLATFORM_IOS - The action platform is iOS. */
	ACTION_PLATFORM_IOS = 'ACTION_PLATFORM_IOS',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

export enum LocationType {
	/** LOCATION_TYPE_UNSPECIFIED - Location type unspecified. */
	LOCATION_TYPE_UNSPECIFIED = 'LOCATION_TYPE_UNSPECIFIED',
	/** VISITED_LOCATION - The location where this service visits. */
	VISITED_LOCATION = 'VISITED_LOCATION',
	/**
	 * START_LOCATION - The location where this service starts, also serves as MEETING_LOCATION
	 * or START_LOCATION.
	 */
	START_LOCATION = 'START_LOCATION',
	/** END_LOCATION - The location where this service ends. */
	END_LOCATION = 'END_LOCATION',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/** Depth of integration supported. */
export enum IntegrationType {
	/** INTEGRATION_TYPE_UNSPECIFIED - Defaults to END_TO_END. */
	INTEGRATION_TYPE_UNSPECIFIED = 'INTEGRATION_TYPE_UNSPECIFIED',
	/** INTEGRATION_TYPE_END_TO_END - Complete integration that allows end to end booking through Google. */
	INTEGRATION_TYPE_END_TO_END = 'INTEGRATION_TYPE_END_TO_END',
	/**
	 * INTEGRATION_TYPE_INVENTORY_ONLY - Feed integration that does not allow end to end booking through Google.
	 * Only merchants, services, and (optionally) availability data need
	 * to be sent.
	 */
	INTEGRATION_TYPE_INVENTORY_ONLY = 'INTEGRATION_TYPE_INVENTORY_ONLY',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

export interface FeedMetadata {
	/**
	 * Instructs us how to process the feed: either as a shard of a complete feed,
	 * or as a shard of an incremental update. (required)
	 */
	processing_instruction?: FeedMetadata_ProcessingInstruction | undefined
	/**
	 * The current shard and total number of shards for this feed.
	 *
	 * Shard number is assumed to be zero-based.
	 *
	 * There does not need to be any relationship to the file name.
	 *
	 * Shards do not need to be transferred in order, and they may not be
	 * processed in order. (both required)
	 */
	shard_number?: number | undefined
	total_shards?: number | undefined
	/**
	 * An identifier that must be consistent across all shards in a feed.
	 * This value must be globally unique across each feed type.
	 *
	 * This value ensures that complete feeds spanning multiple shards are
	 * processed together correctly.
	 *
	 * Clients only need to set this value when the processing_instruction is set
	 * to PROCESS_AS_COMPLETE and the feed spans multiple shards (defined by
	 * total_shards).
	 *
	 * Feeds that span multiple shards must set this nonce to the same value.
	 * (required if total shards > 1)
	 */
	nonce?: string | undefined
	/**
	 * The timestamp at which this feed shard was generated.
	 *
	 * In Unix time format (seconds since the epoch). (required)
	 */
	generation_timestamp?: string | undefined
}

export enum FeedMetadata_ProcessingInstruction {
	/** PROCESS_UNKNOWN - Do not use. */
	PROCESS_UNKNOWN = 'PROCESS_UNKNOWN',
	/**
	 * PROCESS_AS_COMPLETE - This Feed message is one shard of a complete feed. Anything previously
	 * supplied by this partner will be deleted; the contents of this feed
	 * represent the entire state of the world.
	 */
	PROCESS_AS_COMPLETE = 'PROCESS_AS_COMPLETE',
	/**
	 * PROCESS_AS_INCREMENTAL - Do not use. This value is deprecated.
	 * Feed message is one shard of an incremental feed.
	 * Existing entities will be left untouched except as modified in this feed.
	 */
	PROCESS_AS_INCREMENTAL = 'PROCESS_AS_INCREMENTAL',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

export interface MerchantFeed {
	metadata?: FeedMetadata | undefined
	merchant?: Merchant[] | undefined
}

/**
 * Info about a merchant that is on the aggregator's platform.
 * A merchant feed should be a list of this message.
 */
export interface Merchant {
	/**
	 * An opaque string generated by the partner that identifies a merchant.
	 * Must be unique across all merchants.
	 * Strongly recommended to only include URL-safe characters. (required)
	 */
	merchant_id?: string | undefined
	/**
	 * The name, telephone, url and geo are used to support matching partner
	 * inventory with merchants already present on Google Maps. This information
	 * will not be displayed.
	 *
	 * The name of the merchant. (required)
	 */
	name?: string | undefined
	/**
	 * The contact telephone number of the merchant including its country and area
	 * codes, e.g. +14567891234. Highly recommended. (optional)
	 */
	telephone?: string | undefined
	/** The url of the merchant's public website. Highly recommended. (optional) */
	url?: string | undefined
	/**
	 * The Geo info of the merchant, including latitude, longitude, and address.
	 * (required)
	 */
	geo?: GeoCoordinates | undefined
	/**
	 * The category of the business in aggregator's platform. (required)
	 * You should categorize this business as you categorize it in your inventory.
	 * We will use your provided category as a parameter in trying to determine
	 * the best location match to the physical business.
	 */
	category?: string | undefined
	/**
	 * This field is deprecated, please use tax_rate instead.
	 *
	 * @deprecated
	 */
	tax_rate_basis_points?: number | undefined
	/**
	 * The merchant's tax rate. If present this field overrides the deprecated
	 * tax_rate_basis_points field. An empty message (i.e. tax_rate { }) will
	 * reset the applied tax rate to zero.
	 *
	 * This field is required for payments integration. (optional)
	 */
	tax_rate?: TaxRate | undefined
	/**
	 * Restrictions to the payment methods this merchant accepts. We assume no
	 * restrictions exist if this field is not set. (optional)
	 */
	payment_restrictions?: PaymentRestrictions | undefined
	/**
	 * Payment options available for this merchant. Services under this merchant
	 * will be able to individually limit the payment options they allow.
	 * (optional)
	 */
	payment_option?: PaymentOption[] | undefined
	/**
	 * Configuration for a tokenized payment processor, if the merchant has
	 * support for it.
	 */
	tokenization_config?: TokenizationConfig | undefined
	/**
	 * The specific merchant's Terms and Conditions displayed to the user when a
	 * service is being booked through Reserve with Google.
	 * In addition to these the aggregator partner's Terms and Conditions are
	 * always displayed to the user and must not be provided here. (optional)
	 */
	terms?: Terms | undefined
	/**
	 * An opaque string that identifies the consumer-facing brand to use when
	 * displaying partner attribution. This field allows partners with multiple
	 * consumer-facing brands to provide merchants for all brands within the same
	 * feed.
	 *
	 * A brand consists of consumer-facing properties like the name, logo, Terms
	 * of Service, and Privacy Policy.
	 *
	 * If there is only one consumer-facing partner brand, this field does not
	 * need to be set and can be ignored.
	 *
	 * If the partner...
	 *
	 *   Does not have multiple consumer-facing brands?
	 *     --> Ignore this field
	 *
	 *   Has Multiple Brands that are configured?
	 *
	 *       If this field is set
	 *         --> Associated consumer-facing brand attribution is used
	 *
	 *       If this field is unset or the empty string
	 *         --> Default consumer-facing brand attribution is used
	 *
	 * Careful Note: most partners do not need to set this field. If a partner
	 * wishes to use this field, they must contact us first to configure separate
	 * brands, including the default brand.
	 */
	brand_id?: string | undefined
	/**
	 * Hints to help Google match a merchant to a place on Google Maps.
	 * Note: Typically, this field does not need to be set, as Google will match
	 * merchants to places on Google Maps using the information provided above.
	 * (optional)
	 */
	matching_hints?: MerchantMatchingHints | undefined
	/**
	 * Definitions for any service attributes used to describe the Services for
	 * this Merchant. (optional)
	 */
	service_attribute?: ServiceAttribute[] | undefined
	/**
	 * An action URL with associated language, list of countries restricted to,
	 * type, and optional platform that indicates which platform this action
	 * should be performed on. This action link is specifically for the merchant,
	 * please use the ActionLink in the service feed to link to a specific
	 * service.
	 */
	action_link?: ActionLink[] | undefined
	/**
	 * The linkout template that specifies how Google should generate the
	 * partner's URL to reserve a table on their platform.
	 *
	 * Note that currently only the first one will be used if multiple are
	 * provided.
	 *
	 * The URI template has support for fields which will be populated based
	 * on the user's reservation selections, all required fields are needed to
	 * build a reservation URL successfully:
	 * * (required) party_size, int: The size of the party for which the user is
	 * requesting a reservation.
	 * * (required) selected_date_time, ISO 8601 datetime
	 * (https://en.wikipedia.org/wiki/ISO_8601): The time the user is requesting a
	 * reservation for.
	 * * (optional) merchant_id, string: The ID of the Merchant the user is
	 * requesting a reservation with, not needed if template already includes a
	 * merchant identifier.
	 * * (optional) room_id, string: The id of the room the user is requesting a
	 * reservation for.
	 */
	reservation_linkout_template?: LinkoutTemplate[] | undefined
	/**
	 * General advisements from a specific merchant for a user joining a waitlist
	 * through Reserve with Google. Individual text fields in the advisement
	 * should be limited to 100 bytes in length.
	 */
	waitlist_advisement?: Advisement | undefined
	/**
	 * Economic Operator information associated to this specific merchant, if
	 * applicable for an end to end payments integration.
	 * For further info, refer to:
	 * https://developers.google.com/actions-center/verticals/reservations/e2e/partner-portal/testing/regulatory-requirements#economic-operator
	 *
	 * (optional)
	 */
	economic_operator?: EconomicOperator | undefined
}

/**
 * The Geo data of a location, including latitude, longitude, and address.
 * At least one of [lat/lng or address] should be provided (or both).
 */
export interface GeoCoordinates {
	/** [-90, +90] degrees (inclusive). (optional) */
	latitude?: number | undefined
	/** [-180, +180] degrees (inclusive). (optional) */
	longitude?: number | undefined
	/** Postal address of the location, preferred. */
	address?: PostalAddress | undefined
	/**
	 * An unstructured address could also be provided as a fallback.
	 * E.g. "1600 amphitheatre parkway mountain view, ca 94043"
	 */
	unstructured_address?: string | undefined
}

/** The postal address for a merchant. */
export interface PostalAddress {
	/** The country, using ISO 3166-1 alpha-2 country code, e.g. "US" (required) */
	country?: string | undefined
	/** The locality/city, e.g. "Mountain View". (required) */
	locality?: string | undefined
	/**
	 * The region/state/province, e.g. "CA". This field is only required in
	 * countries where region is commonly a part of the address. (optional)
	 */
	region?: string | undefined
	/** The postal code, e.g. "94043". (required) */
	postal_code?: string | undefined
	/** The street address, e.g. "1600 Amphitheatre Pkwy". (required) */
	street_address?: string | undefined
}

/**
 * A tax rate applied when charging the user for a service, and which can be set
 * on either a per merchant, or per service basis.
 */
export interface TaxRate {
	/**
	 * A tax rate in millionths of one percent, effectively giving 6 decimals of
	 * precision. For example, if the tax rate is 7.253%, this field should be set
	 * to 7253000.
	 *
	 * If this field is left unset or set to 0, the total price charged to a user
	 * for any service provided by this merchant is the exact price specified by
	 * Service.price. The service price is assumed to be exempt from or already
	 * inclusive of applicable taxes. Taxes will not be shown to the user as a
	 * separate line item.
	 *
	 * If this field is set to any nonzero value, the total price charged to a
	 * user for any service provided by this merchant will include the service
	 * price plus the tax assessed using the tax rate provided here. Fractions of
	 * the smallest currency unit (for example, fractions of one cent) will be
	 * rounded using nearest even rounding. Taxes will be shown to the user as a
	 * separate line item. (required)
	 */
	micro_percent?: number | undefined
}

/** Restrictions to the credit card types this merchant accepts. */
export interface CreditCardRestrictions {
	/**
	 * A list of supported credit cards. No credit cards are supported if empty.
	 * (optional)
	 */
	credit_card_type?: CreditCardRestrictions_CreditCardType[] | undefined
}

/** A credit card type. */
export enum CreditCardRestrictions_CreditCardType {
	/** CREDIT_CARD_TYPE_UNSPECIFIED - Unused. */
	CREDIT_CARD_TYPE_UNSPECIFIED = 'CREDIT_CARD_TYPE_UNSPECIFIED',
	/** VISA - A Visa credit card. */
	VISA = 'VISA',
	/** MASTERCARD - A Mastercard credit card. */
	MASTERCARD = 'MASTERCARD',
	/** AMERICAN_EXPRESS - An American Express credit card. */
	AMERICAN_EXPRESS = 'AMERICAN_EXPRESS',
	/** DISCOVER - A Discover credit card. */
	DISCOVER = 'DISCOVER',
	/** JCB - A JCB credit card. */
	JCB = 'JCB',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/** Restrictions to the payment methods this merchant accepts. */
export interface PaymentRestrictions {
	/**
	 * Restrictions to the credit cards this merchant accepts. We assume all
	 * credit cards are accepted if this field is not set.
	 * Note that the list of cards supported by CreditCardType will grow over
	 * time, meaning that leaving this empty subjects a configuration to future
	 * changes. (optional)
	 */
	credit_card_restrictions?: CreditCardRestrictions | undefined
}

/**
 * A payment option, which can be used to pay for services provided by a
 * merchant. Payment options can be shared among multiple merchants
 * (e.g. merchants belonging to the same chain).
 */
export interface PaymentOption {
	/**
	 * An opaque string from an aggregator partner to identify a payment option.
	 *
	 * This id is global to the whole aggregator, and re-using a value across
	 * multiple merchants will allow a user to pay with the corresponding payment
	 * option across those merchants.
	 *
	 * When re-using an id across multiple merchants, updating any value for a
	 * payment option under one merchant will also update any other payment option
	 * with the same id, under a different merchant. As such, it's a best practice
	 * to have all payment options sharing the same id, always be updated to
	 * identical values, to avoid any possibility of nondeterministic behavior.
	 *
	 * Do NOT confuse it with the internal payment option id. (required)
	 */
	payment_option_id?: string | undefined
	/** The name of the payment option. This can be user visible. (required) */
	name?: string | undefined
	/** A description of the payment option. This can be user visible. (optional) */
	description?: string | undefined
	/** The price of the payment option. (required) */
	price?: Price | undefined
	/**
	 * The tax rate for this payment option. If present this field overrides the
	 * tax_rate field present in the Merchant or Service. An empty message
	 * (i.e. tax_rate { }) will reset the applied tax rate to zero. (optional)
	 */
	tax_rate?: TaxRate | undefined
	/**
	 * The type of this payment option. Single-use for drop-ins, multi-use for
	 * packs, and unlimited for memberships. (required)
	 */
	payment_option_type?: PaymentOption_PaymentOptionType | undefined
	/**
	 * How many sessions this payment option can be used for. Valid only for
	 * multi-session / packs, where the value should be > 1.
	 * (required if payment_option_type is PAYMENT_OPTION_MULTI_USE)
	 */
	session_count?: string | undefined
	/** The payment option can be purchased within this interval. (optional) */
	purchase_interval?: TimeRange | undefined
	/**
	 * The payment option can be used within this interval (e.g. special price
	 * for January 2017).
	 * If present, this overrides valid_duration_sec and activation_type.
	 * (optional)
	 */
	valid_interval?: TimeRange | undefined
	/**
	 * Duration of the payment option validity (e.g. 30 day membership).
	 * (optional)
	 */
	valid_duration_sec?: string | undefined
	/**
	 * Defines how the validity start date is determined for this payment option.
	 * (required)
	 */
	activation_type?: PaymentOption_ActivationType | undefined
	/**
	 * Restricts the users eligible to purchase this payment option. Can be used
	 * to restrict a promotional payment option to a subset of users. If not set,
	 * all users are eligible. (optional)
	 */
	user_restriction?: UserPurchaseRestriction | undefined
}

/** A payment option type. */
export enum PaymentOption_PaymentOptionType {
	/** PAYMENT_OPTION_TYPE_UNSPECIFIED - Unused. */
	PAYMENT_OPTION_TYPE_UNSPECIFIED = 'PAYMENT_OPTION_TYPE_UNSPECIFIED',
	/** PAYMENT_OPTION_SINGLE_USE - Payment option can only be used once. */
	PAYMENT_OPTION_SINGLE_USE = 'PAYMENT_OPTION_SINGLE_USE',
	/** PAYMENT_OPTION_MULTI_USE - Payment option can be used if its session count > 0. */
	PAYMENT_OPTION_MULTI_USE = 'PAYMENT_OPTION_MULTI_USE',
	/**
	 * PAYMENT_OPTION_UNLIMITED - Payment option can be used within its valid time range - session count
	 * is inapplicable.
	 */
	PAYMENT_OPTION_UNLIMITED = 'PAYMENT_OPTION_UNLIMITED',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/** Defines how the validity start date is determined. */
export enum PaymentOption_ActivationType {
	/** ACTIVATION_TYPE_UNSPECIFIED - Unused. */
	ACTIVATION_TYPE_UNSPECIFIED = 'ACTIVATION_TYPE_UNSPECIFIED',
	/** ACTIVATION_ON_PURCHASE - Validity starts at the time of purchase. */
	ACTIVATION_ON_PURCHASE = 'ACTIVATION_ON_PURCHASE',
	/** ACTIVATION_ON_FIRST_USE - Validity starts when the payment option is used for the first time. */
	ACTIVATION_ON_FIRST_USE = 'ACTIVATION_ON_FIRST_USE',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

export interface UserPurchaseRestriction {
	/**
	 * A payment option that can only be purchased by users who have never
	 * purchased from the same merchant before. (required if new_to_payment_option
	 * is not set)
	 */
	new_to_merchant?: boolean | undefined
	/**
	 * A payment option that can only be purchased by users who have never
	 * purchased the same payment option before. (required if new_to_payment is
	 * not set)
	 */
	new_to_payment_option?: boolean | undefined
}

/** A closed-open time range, i.e. [begin_sec, end_sec) */
export interface TimeRange {
	/** Seconds of UTC time since Unix epoch (required) */
	begin_sec?: string | undefined
	/** Seconds of UTC time since Unix epoch (required) */
	end_sec?: string | undefined
}

/** A configuration for a payment processor, setup on a per Merchant basis. */
export interface PaymentProcessorConfig {
	/**
	 * Defines the payment processor partner this configuration applies to.
	 * (required)
	 */
	processor?: PaymentProcessorConfig_Processor | undefined
	/**
	 * The key used to identify this merchant with the payment processor.
	 *
	 * For Stripe, refer to: https://stripe.com/docs/dashboard#api-keys
	 * For Braintree, refer to:
	 * https://articles.braintreepayments.com/control-panel/important-gateway-credentials
	 * (required)
	 */
	public_key?: string | undefined
	/**
	 * The API version number sent to the payment processor along with payment
	 * requests. (required)
	 */
	version?: string | undefined
}

/** Defines a specific payment processor partner. */
export enum PaymentProcessorConfig_Processor {
	/** PROCESSOR_UNSPECIFIED - Unused */
	PROCESSOR_UNSPECIFIED = 'PROCESSOR_UNSPECIFIED',
	/** PROCESSOR_STRIPE - A configuration for payments with Stripe. */
	PROCESSOR_STRIPE = 'PROCESSOR_STRIPE',
	/** PROCESSOR_BRAINTREE - A configuration for payments with Braintree. */
	PROCESSOR_BRAINTREE = 'PROCESSOR_BRAINTREE',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/**
 * A configuration for payment-processor tokenization, set up on a per-Merchant
 * basis.
 */
export interface TokenizationConfig {
	/**
	 * A tokenization configuration will typically have one
	 * tokenization_parameter whose key is "gateway" and whose value is the
	 * name of the processor.
	 *
	 * The rest of the parameters are dependent on the processor.  See
	 * documentation from Google Pay and your processor for further information.
	 * https://developers.google.com/pay/api/web/object-reference# \
	 *   PaymentMethodTokenizationSpecification
	 * https://developers.google.com/pay/api/#participating-google-pay-processors
	 *
	 * Braintree example:
	 * tokenization_parameter { key: "gateway" value: "braintree" }
	 * tokenization_parameter { key: "braintree:apiVersion" value: "v1" }
	 * tokenization_parameter { key: "braintree:sdkVersion" value: "2.30.0" }
	 * tokenization_parameter { key: "braintree:merchantId" value: "abcdef" }
	 * tokenization_parameter { key: "braintree:clientKey"
	 *                          value: "production_xxx_yyy" }
	 *
	 * Stripe example:
	 * tokenization_parameter { key: "gateway" value: "stripe" }
	 * tokenization_parameter { key: "stripe:version" value: "2018-02-28" }
	 * tokenization_parameter { key: "stripe:publishableKey" value: "pk_1234" }
	 *
	 * Adyen example:
	 * tokenization_parameter { key: "gateway" value: "adyen" }
	 * tokenization_parameter { key: "gatewayMerchantId" value: "yourId" }
	 */
	tokenization_parameter?: { [key: string]: string } | undefined
	/**
	 * Include in the payment token the user's billing information as entered into
	 * Google Pay with their FOP (see above).
	 */
	billing_information_format?: TokenizationConfig_BillingInformationFormat | undefined
	/**
	 * Name of the Merchant Of Record (MOR).  This user-visible name will be shown
	 * in 3DS2 challenges.  In some cases, this is the Merchant, in others this is
	 * the Aggregator.
	 */
	merchant_of_record_name?: string | undefined
	/** Country where transaction will be processed, in ISO 3166-1 alpha-2 form. */
	payment_country_code?: string | undefined
	/**
	 * Per-Card Network processing parameters.
	 *
	 * These are currently only required for PSD2
	 * (https://en.wikipedia.org/wiki/Payment_Services_Directive)
	 * processing when payment_country_code is a European country where PSD2 is in
	 * effect.  They are also only currently required for VISA and
	 * AMERICAN_EXPRESS.
	 */
	card_network_parameters?: TokenizationConfig_CardNetworkParameters[] | undefined
	/**
	 * Defines types of cardholder data that are accepted by the gateway.
	 * If not specified, no restrictions are applied.
	 *
	 * Note that partners who use commercial gateways should leave this
	 * empty unless their gateway provider has specified otherwise.  Restricting
	 * allowed_auth_methods is most useful in the scenario that a partner
	 * integrates with GPay as a gateway themselves.
	 */
	allowed_auth_methods?: TokenizationConfig_AuthMethod[] | undefined
}

/**
 * How much of the Billing Address to require of the user and include in the
 * token. The enum values correspond to parameters in the Google Pay API (see
 * https://developers.google.com/pay/api/web/reference/object\
 *  #BillingAddressParameters).
 */
export enum TokenizationConfig_BillingInformationFormat {
	BILLING_INFORMATION_FORMAT_UNSPECIFIED = 'BILLING_INFORMATION_FORMAT_UNSPECIFIED',
	/** MIN - name, country code, and postal code (GPay default setting). */
	MIN = 'MIN',
	/** FULL - name, street address, locality, region, country code, and postal code */
	FULL = 'FULL',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/**
 * Fields supported to authorize a card transaction.
 *
 * See the GPay documentation at
 * https://developers.google.com/pay/api/web/reference/object#CardParameters
 */
export enum TokenizationConfig_AuthMethod {
	AUTH_METHOD_UNSPECIFIED = 'AUTH_METHOD_UNSPECIFIED',
	/**
	 * PAN_ONLY - This authentication method is associated with payment cards stored on
	 * file with the user's Google Account. Returned payment data includes
	 * personal account number (PAN) with the expiration month and the
	 * expiration year.
	 */
	PAN_ONLY = 'PAN_ONLY',
	/**
	 * CRYPTOGRAM_3DS - This authentication method is associated with cards stored as Android
	 * device tokens. Returned payment data includes a 3-D Secure (3DS)
	 * cryptogram generated on the device.
	 */
	CRYPTOGRAM_3DS = 'CRYPTOGRAM_3DS',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

export interface TokenizationConfig_TokenizationParameterEntry {
	key: string
	value: string
}

/** Per CardNetwork Processing information. */
export interface TokenizationConfig_CardNetworkParameters {
	/** The Card Network that these parameters are about */
	card_network?: CreditCardRestrictions_CreditCardType | undefined
	/**
	 * The Bank Identification Number of the acquiring bank used for processing
	 * of the card.
	 *
	 * If this value is not known to you, you should ask your acquirer or
	 * merchant processor representative.
	 */
	acquirer_bin?: string | undefined
	/**
	 * The merchant identifier assigned by the acquirer to the merchant for use
	 * in transaction authorization (for Visa and American Express
	 * transactions).
	 *
	 * If this value is not known to you, you should ask the acquirer or
	 * merchant processor representative.
	 */
	acquirer_merchant_id?: string | undefined
}

/**
 * A set of rules and guidelines that are displayed to the
 * user in order to make a booking through Reserve with Google.
 */
export interface Terms {
	/** The URL to the Terms and Conditions. (optional) */
	url?: string | undefined
	/**
	 * The text to be displayed to the user.
	 * Use localized_text below for new integrations.
	 */
	text?: string | undefined
	/** The localized text to be displayed to the user. (required) */
	localized_text?: Text | undefined
}

/**
 * Advisements that are displayed to the user when booking through Reserve with
 * Google.
 */
export interface Advisement {
	/**
	 * Custom message to be displayed to the user when booking through
	 * Reserve with Google.
	 */
	text?: Text | undefined
}

/** Economic Operator information for the Merchant. */
export interface EconomicOperator {
	/**
	 * Name, address, telephone number and email address of the economic operator,
	 * defined as the manufacturer, authorized representative, importer,
	 * distributor, fulfillment service provider or any other natural or legal
	 * person subject to obligations related to the manufacture of products,
	 * making them available, or putting them into service.
	 * Freeform string representation of the economic_operator. This information
	 * may be formatted using " " and "\n".
	 */
	text?: Text | undefined
}

/** Hints used to help Google match a merchant to a place on Google Maps. */
export interface MerchantMatchingHints {
	/**
	 * The Place ID for a place in the Google Places database and on Google Maps.
	 * See https://developers.google.com/places/place-id for more about Place IDs.
	 * If this is provided, Google will use it as a hint when matching, and
	 * prioritize the hint over other candidates.
	 */
	place_id?: string | undefined
}

/**
 * Service attributes are partner-defined categories that describe the Services
 * for a Merchant. For example, a bank may define an "Account Type"
 * service attribute with possible values of "Personal" and "Business", while a
 * hair salon may define a "Service Type" service attribute with possible
 * values of "Haircut", "Color", and "Style".
 */
export interface ServiceAttribute {
	/**
	 * An identifier that uniquely identifies this service attribute among others
	 * for the same merchant, e.g. "account-type".
	 */
	attribute_id?: string | undefined
	/** A user-visible name for this attribute, e.g. "Account Type". */
	attribute_name?: string | undefined
	/** All possible values for this service attribute. */
	value?: ServiceAttribute_Value[] | undefined
}

/** Represents a possible value for a particular service attribute. */
export interface ServiceAttribute_Value {
	/**
	 * An identifier that uniquely identifies this value among others for
	 * this service attribute, e.g. "personal".
	 */
	value_id?: string | undefined
	/** A user-visible name for the value, e.g. "Personal". */
	value_name?: string | undefined
}

export interface ServiceFeed {
	metadata?: FeedMetadata | undefined
	service?: Service[] | undefined
}

/** The definition of a service provided by a merchant. */
export interface Service {
	/**
	 * An opaque string from an aggregator partner which uniquely identifies a
	 * merchant. (required)
	 */
	merchant_id?: string | undefined
	/**
	 * An opaque string from an aggregator partner which uniquely identifies the
	 * service. (required)
	 */
	service_id?: string | undefined
	/**
	 * The name of the service. Deprecated. Please use localized_service_name.
	 *
	 * @deprecated
	 */
	name?: string | undefined
	/**
	 * The name of the service, e.g. "Men's haircut". Possibly in several locales.
	 * (required)
	 */
	localized_service_name?: Text | undefined
	/**
	 * The description of the service.
	 * Deprecated. Please use localized_description.
	 *
	 * @deprecated
	 */
	description?: string | undefined
	/**
	 * The description of the product. Limited formatting options are allowed in
	 * the HTML format. Supported tags:
	 *   * h1-h5
	 *   * ul, ol, li
	 *   * strong, italic, em
	 *   * p, br
	 * Other tags are not supported and will be removed. CSS, tables, style
	 * property, `a` links are not supported. Images are not allowed, use the
	 * related_media field instead.
	 * Important notes:
	 *   * Try not to use other tags except for the supported ones mentioned
	 *     above, because the contents within unsupported tags will be stripped,
	 *     and may lead to an undesirable user experience.
	 *   * Try avoid deep nested structures like more than 3 different heading
	 *     levels or nested lists. Keeping the structure flat, simple, and
	 *     straightforward, helps to create a better user experience.
	 *   * Do not duplicate info from the product_features field below in the
	 *     description as both would normally be shown side by side.
	 * Recommended to not exceed length of 10000 in any language. Max length:
	 * 16000.
	 * Recommended.
	 * (optional)
	 */
	localized_description?: Text | undefined
	/**
	 * The price of the service. (optional, overridden when payment options or
	 * ticket types present)
	 */
	price?: Price | undefined
	/**
	 * Describes how the price is interpreted and displayed to the user. Can be
	 * used by any vertical except Dining and Things To Do to configure display of
	 * the service price. (optional)
	 */
	price_interpretation?: PriceInterpretation | undefined
	/** Rules to book/cancel an appointment. (optional) */
	rules?: SchedulingRules | undefined
	/** Whether a prepayment is required, optional or not supported. (optional) */
	prepayment_type?: Service_PrepaymentType | undefined
	prepayment_terms?: Service_PrepaymentTerms | undefined
	/**
	 * The service's tax rate. If present this field overrides any tax_rate set at
	 * the merchant level. An empty message (i.e. tax_rate { }) will reset the
	 * applied tax rate to zero. (optional)
	 */
	tax_rate?: TaxRate | undefined
	/**
	 * A list of ids referencing the payment options which can be used to pay
	 * for this service. The actual payment options are defined at the Merchant
	 * level, and can also be shared among multiple Merchants. (optional)
	 */
	payment_option_id?: string[] | undefined
	/**
	 * Defines how a deposit may be charged to the user. Can be overridden at the
	 * availability level. (optional)
	 */
	deposit?: Deposit | undefined
	/**
	 * Defines a no show fee that may be charged to the user. Can be overridden
	 * at the availability level. (optional)
	 */
	no_show_fee?: NoShowFee | undefined
	/**
	 * Indicates whether the user must provide a credit card in order to book this
	 * service.
	 * This value can be overridden at the availability level. (optional)
	 */
	require_credit_card?: RequireCreditCard | undefined
	/**
	 * Additional information which needs to be added if the service requires the
	 * user to pay directly to the merchant. IMPORTANT NOTE: RwG would not be
	 * involved in this transaction. (Optional. Required if virtual_session is
	 * defined and prepayment_type is NOT set to REQUIRED).
	 */
	direct_merchant_payment?: DirectMerchantPayment | undefined
	/**
	 * An action link related to this service. If action link exists, type (see
	 * below) must be set in the Service.
	 */
	action_link?: ActionLink[] | undefined
	/** The predefined type of this service. (optional) */
	type?: Service_ServiceType | undefined
	/**
	 * Types of tickets that can be booked/purchased for this service. Only
	 * supported in order based booking API, see
	 * https://developers.google.com/maps-booking/guides/partner-implementing-booking-server-1a
	 * (optional)
	 */
	ticket_type?: TicketType[] | undefined
	/**
	 * Photos related to this service. Google will crawl these media to ensure
	 * that they are displayed correctly to end-users. (optional)
	 */
	related_media?: RelatedMedia[] | undefined
	/**
	 * Service attribute values that apply to this service (optional).
	 * Each Service may have zero or more values for each service attribute
	 * defined in the corresponding Merchant.
	 */
	service_attribute_value_id?: ServiceAttributeValueId[] | undefined
	/**
	 * Rules related to joining the waitlist. Should be populated if the service
	 * and merchant support waitlist functionality. Should not be populated
	 * otherwise.
	 */
	waitlist_rules?: WaitlistRules | undefined
	/** Additional information unique to the event ticketing vertical. (optional) */
	ticketing_vertical_specific_data?: TicketingVerticalSpecificData | undefined
	/** User rating for this service as an aggregate metric over all reviews. */
	rating?: Rating | undefined
	/** Additional information unique to home service vertical. (optional) */
	home_service_data?: HomeServiceData | undefined
	/**
	 * Information about virtual session. (Optional. Required if enabling
	 * virtual services)
	 */
	virtual_session?: VirtualSession | undefined
	/** Ranking hint for this service. Optional. */
	ranking_hint?: ServiceRankingHint | undefined
	/**
	 * A template specifying how Google should generate URLs to external site.
	 * Used for Dining Reservations Payment Redirect Partners only.
	 */
	uri_template?: UriTemplate | undefined
}

/** Enum to indicate the prepayment type. */
export enum Service_PrepaymentType {
	/** PREPAYMENT_TYPE_UNSPECIFIED - By default we will assume that the prepayment is NOT_SUPPORTED. */
	PREPAYMENT_TYPE_UNSPECIFIED = 'PREPAYMENT_TYPE_UNSPECIFIED',
	/** REQUIRED - The user has to pay this service at the booking time. */
	REQUIRED = 'REQUIRED',
	/**
	 * OPTIONAL - The user can choose to pre-pay this service at the booking time or later,
	 * but it is not required in order to book.
	 */
	OPTIONAL = 'OPTIONAL',
	/** NOT_SUPPORTED - The prepayment is not supported for this service. */
	NOT_SUPPORTED = 'NOT_SUPPORTED',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

export enum Service_ServiceType {
	SERVICE_TYPE_UNSPECIFIED = 'SERVICE_TYPE_UNSPECIFIED',
	/** SERVICE_TYPE_DINING_RESERVATION - Service that provides dining reservation. */
	SERVICE_TYPE_DINING_RESERVATION = 'SERVICE_TYPE_DINING_RESERVATION',
	/**
	 * SERVICE_TYPE_FOOD_ORDERING - Service that provides food ordering in general, could be either takeout
	 * or delivery or both.
	 */
	SERVICE_TYPE_FOOD_ORDERING = 'SERVICE_TYPE_FOOD_ORDERING',
	/** SERVICE_TYPE_FOOD_DELIVERY - Service that only provides food delivery. */
	SERVICE_TYPE_FOOD_DELIVERY = 'SERVICE_TYPE_FOOD_DELIVERY',
	/** SERVICE_TYPE_FOOD_TAKEOUT - Service that only provides food takeout. */
	SERVICE_TYPE_FOOD_TAKEOUT = 'SERVICE_TYPE_FOOD_TAKEOUT',
	/**
	 * SERVICE_TYPE_EVENT_TICKET - Services that provide event based ticketing (e.g. concerts, sporting
	 * events, shows). Do not use for Reserve with Google integrations.
	 */
	SERVICE_TYPE_EVENT_TICKET = 'SERVICE_TYPE_EVENT_TICKET',
	SERVICE_TYPE_TRIP_TOUR = 'SERVICE_TYPE_TRIP_TOUR',
	/**
	 * SERVICE_TYPE_APPOINTMENT - Service that provides appointments or classes. Recommended for (1) health
	 * and fitness, (2) spa and beauty, and (3) financial consults and
	 * evaluations services. Please see the supported service types:
	 * https://developers.google.com/maps-booking/guides/end-to-end-integration/overview
	 */
	SERVICE_TYPE_APPOINTMENT = 'SERVICE_TYPE_APPOINTMENT',
	/**
	 * SERVICE_TYPE_ONLINE_APPOINTMENT - Service that provides appointment for an online class or session which
	 * will be fully virtual. Must be set if enabling virtual service bookings.
	 */
	SERVICE_TYPE_ONLINE_APPOINTMENT = 'SERVICE_TYPE_ONLINE_APPOINTMENT',
	/**
	 * SERVICE_TYPE_SHOPPING - Service that allows users to shop from the given merchant. It could
	 * either be delivery or pickup.
	 */
	SERVICE_TYPE_SHOPPING = 'SERVICE_TYPE_SHOPPING',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/** Specific information around when prepayment is completed. */
export interface Service_PrepaymentTerms {
	charge_timing?: Service_PrepaymentTerms_ChargeTiming | undefined
}

/**
 * Enum to specify when the charge will occur relative to the purchase
 * time.
 */
export enum Service_PrepaymentTerms_ChargeTiming {
	CHARGE_TIMING_UNSPECIFIED = 'CHARGE_TIMING_UNSPECIFIED',
	CHARGE_NOW = 'CHARGE_NOW',
	CHARGE_LATER = 'CHARGE_LATER',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/** The price of a service or a fee. */
export interface Price {
	/**
	 * The price in micro-units of the currency.
	 * For example: 1.95 USD is 1950000 in micro-units.
	 * If your price contains fractions of the smallest currency unit, then it
	 * will be rounded using nearest even rounding (e.g. 2.5 cents rounded
	 * to 2 cents, 3.5 cents rounded to 4 cents, 0.5 cents rounded to 0 cents,
	 * 2.51 cents rounded to 3 cents). (required)
	 */
	price_micros?: string | undefined
	/** The currency of the price that is defined in ISO 4217. (required) */
	currency_code?: string | undefined
	/**
	 * An optional and opaque string that identifies the pricing option that is
	 * associated with the extended price. (optional)
	 */
	pricing_option_tag?: string | undefined
}

/**
 * A possibly-localized text payload. Some Text fields may contain marked-up
 * content.
 */
export interface Text {
	/**
	 * Required. Text value in an unknown locale, which will be displayed if
	 * `localized_value` for the user locale is empty or missing. The locale for
	 * this value may depend on the partner or service provider, and it should not
	 * be assumed to be any specific language.
	 */
	value?: string | undefined
	/** Per-locale text values. Required. */
	localized_value?: LocalizedString[] | undefined
}

/** Instance of a string in one locale. */
export interface LocalizedString {
	/**
	 * IETF BCP 47 language code, such as "en", "mas", "zh-Hant", "de-CH-1901".
	 * See http://www.w3.org/International/articles/language-tags/.
	 */
	locale?: string | undefined
	/** Message in the locale above (UTF-8). */
	value?: string | undefined
}

/** The scheduling rules for a service. */
export interface SchedulingRules {
	/**
	 * The duration (in seconds) from when the last booking can be made to
	 * when the availability slot starts.
	 */
	min_advance_booking?: string | undefined
	/**
	 * The duration (in seconds) from when the last booking can be made to
	 * when the availability slot ends. If this field is set, the
	 * "admission_policy" field must be set to TIME_FLEXIBLE to indicate that
	 * users can use the purchased tickets after slots start.
	 */
	min_booking_buffer_before_end_time?: string | undefined
	/**
	 * The minimum advance notice in seconds required to cancel a booked
	 * appointment online. (optional)
	 */
	min_advance_online_canceling?: string | undefined
	/**
	 * The fee for canceling within the minimum advance notice period.
	 *
	 * @deprecated
	 */
	late_cancellation_fee?: Price | undefined
	/**
	 * The fee for no-show without canceling.
	 *
	 * @deprecated
	 */
	noshow_fee?: Price | undefined
	/**
	 * The admission policy that applied to this service. If unset, defaults to
	 * TIME_STRICT. (optional)
	 */
	admission_policy?: SchedulingRules_AdmissionPolicy | undefined
	/**
	 * Scheduling rules cancellation policy (required for Things-to-do).
	 * Defaults to non-refundable.
	 */
	cancellation_policy?: CancellationPolicy | undefined
}

/** The admission policy of this service. */
export enum SchedulingRules_AdmissionPolicy {
	/** ADMISSION_POLICY_UNSPECIFIED - Unused. */
	ADMISSION_POLICY_UNSPECIFIED = 'ADMISSION_POLICY_UNSPECIFIED',
	/**
	 * TIME_STRICT - Customers are required to be present at the start time of the
	 * availability slot, and the service is expected to finish at the
	 * end time of the slot.
	 * Examples of TIME_STRICT use cases:
	 *   * A tour that starts at 9am that requires all attendees to arrive
	 *     at the start time, and returns at around 12pm.
	 *   * A haircut reservation at 3pm on Saturday that will take approximately
	 *   30 minutes.
	 *   * A fitness class from 6pm to 8pm.
	 */
	TIME_STRICT = 'TIME_STRICT',
	/**
	 * TIME_FLEXIBLE - Customers can arrive at any time between the start and end time of the
	 * availability slot to use this booking.
	 *
	 * Examples of TIME_FLEXIBLE use cases:
	 *   * A museum ticket that can be used during any time on the purchase
	 *     date.
	 *   * An afternoon admission to an amusement park that can be used from
	 *     12pm to 9pm.
	 */
	TIME_FLEXIBLE = 'TIME_FLEXIBLE',
	/**
	 * TIMED_ENTRY_WITH_FLEXIBLE_DURATION - Customers need to arrive at the merchant at the start time of the
	 * availability slot but can leave any time they want.
	 *
	 * For example, in the museum admission scenario, a timed entry ticket
	 * for 10am requires the user to be at the museum at 10am. The start time of
	 * availability slots for this service represents the designated entry
	 * time. The end time, however, is used solely as a key to identify the
	 * availability slot for booking.
	 */
	TIMED_ENTRY_WITH_FLEXIBLE_DURATION = 'TIMED_ENTRY_WITH_FLEXIBLE_DURATION',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/** Defines a field that is included in a ServiceIntakeForm. */
export interface ServiceIntakeFormField {
	/**
	 * A string from an aggregator partner which uniquely identifies a form field.
	 * This id should be the same as the id in the corresponding form field
	 * answer and must be unique across both the service level and per ticket
	 * intake forms. (required)
	 */
	id?: string | undefined
	/** The type of this field. (required) */
	type?: ServiceIntakeFormField_FieldType | undefined
	/**
	 * The text shown to the user for this field. Deprecated, please use
	 * `localized_label` instead.
	 *
	 * @deprecated
	 */
	label?: string | undefined
	/**
	 * The text shown to the user for this field. The field can be supplied in
	 * multiple locales. (required)
	 */
	localized_label?: Text | undefined
	/**
	 * Set if and only if the field type is LOCATION_SEARCH. Please use the
	 * "location_id" in the "location" field to specify the location value.
	 */
	value?: string[] | undefined
	/**
	 * Set if and only if the field type is MULTIPLE_CHOICE, CHECKBOXES, or
	 * DROPDOWN. Used to enumerate possible choices.
	 */
	choice_text?: Text[] | undefined
	/** Indicates whether an answer to this field is required by a user. (optional) */
	is_required?: boolean | undefined
	/**
	 * Indicates whether a custom value is allowed in additional to predefined
	 * answers. This is only applicable when the field type is LOCATION_SEARCH.
	 * (optional)
	 */
	allow_custom_answer?: boolean | undefined
	/**
	 * Additional options provided in addition to the provided values. Only
	 * applicable when the field type is LOCATION_SEARCH.
	 * E.g. in addition to the provided location list, another available option
	 * can be "I will contact supplier later". (optional)
	 */
	additional_option?: Text[] | undefined
	/**
	 * If this question should only be shown when the user books certain ticket
	 * types, this field should be set as the set of applicable ticket type ids.
	 * Leave the field empty if the question is always applicable.
	 * (optional)
	 */
	ticket_type_restrict?: string[] | undefined
	/**
	 * The hint text for input, which shows up as a text placeholder. This is only
	 * applicable when the field type is SHORT_ANSWER or PARAGRAPH.
	 * (optional)
	 */
	hint?: Text | undefined
}

/** Enum to indicate the type of field. */
export enum ServiceIntakeFormField_FieldType {
	/** FIELD_TYPE_UNSPECIFIED - Fields of unspecified or unknown type will be ignored. */
	FIELD_TYPE_UNSPECIFIED = 'FIELD_TYPE_UNSPECIFIED',
	/** SHORT_ANSWER - A one-line input field for text. */
	SHORT_ANSWER = 'SHORT_ANSWER',
	/** PARAGRAPH - A multi-line input field for text. */
	PARAGRAPH = 'PARAGRAPH',
	/** MULTIPLE_CHOICE - A set of radio buttons that requires one choice from many options. */
	MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
	/** CHECKBOXES - One or more enumerated items with checkboxes. */
	CHECKBOXES = 'CHECKBOXES',
	/** DROPDOWN - A selection from a dropdown. */
	DROPDOWN = 'DROPDOWN',
	/** BOOLEAN - A yes/no button. */
	BOOLEAN = 'BOOLEAN',
	/**
	 * LOCATION_SEARCH - A search widget that supports finding matched location given user input
	 * from provided location list.
	 */
	LOCATION_SEARCH = 'LOCATION_SEARCH',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/** Defines an intake form that customizes the service provided by a merchant. */
export interface ServiceIntakeForm {
	/** Fields that will be displayed to the user. (required) */
	field?: ServiceIntakeFormField[] | undefined
	/**
	 * If true, this form will be shown to first time customers.
	 * Deprecated. This functionality is not supported for intake forms.
	 *
	 * @deprecated
	 */
	first_time_customers?: boolean | undefined
	/**
	 * If true, this form will be shown to repeat customers.
	 * Deprecated. This functionality is not supported for intake forms.
	 *
	 * @deprecated
	 */
	returning_customers?: boolean | undefined
}

/**
 * A deposit that the user may be charged or have a hold on their credit card
 * for.
 */
export interface Deposit {
	/** Deposit amount. */
	deposit?: Price | undefined
	/** Minimum advance cancellation for the deposit. */
	min_advance_cancellation_sec?: string | undefined
	/** Defines how the deposit is determined from the availability. */
	deposit_type?: PriceType | undefined
}

/**
 * A fee that a user may be charged if they have made a booking but do not
 * show up.
 */
export interface NoShowFee {
	/**
	 * The amount the user may be charged if they do not show up for their
	 * reservation.
	 */
	fee?: Price | undefined
	/** Defines how the fee is determined from the availability. */
	fee_type?: PriceType | undefined
}

/**
 * An action URL with associated language, list of countries restricted to, and
 * optional platform that indicates which platform this action should be
 * performed on.
 */
export interface ActionLink {
	/** The entry point URL for this action link. */
	url?: string | undefined
	/**
	 * The BCP-47 language tag identifying the language in which the content
	 * from this URI is available.
	 */
	language?: string | undefined
	/**
	 * An unordered list of ISO 3166-1 alpha-2 country codes. Leave empty for
	 * unrestricted visibility.
	 */
	restricted_country?: string[] | undefined
	/**
	 * The platform that this action should be performed on. If this field is
	 * unset, ACTION_PLATFORM_WEB_APPLICATION will be used as fallback.
	 */
	platform?: ActionPlatform | undefined
	/** Predetermined type of action associated with an action link. */
	action_link_type?: ActionLink_ActionLinkType | undefined
	/**
	 * Metadata for the order online link.
	 * Supports action with ActionLinkType of ACTION_LINK_TYPE_SHOP_ONLINE.
	 */
	order_online_metadata?: OrderOnlineMetadata | undefined
	/**
	 * Metadata for Food Ordering links.
	 * Supports action type:
	 *   *  `ACTION_LINK_TYPE_ORDER_FOOD_DELIVERY`
	 *   *  `ACTION_LINK_TYPE_ORDER_FOOD_TAKEOUT`
	 * Does NOT support `ACTION_LINK_TYPE_ORDER_FOOD`
	 */
	food_ordering_metadata?: FoodOrderingMetadata | undefined
	event_metadata?: ActionLink_EventMetadata | undefined
}

/** Predetermined type of action associated with an action link. */
export enum ActionLink_ActionLinkType {
	/** ACTION_LINK_TYPE_UNSPECIFIED - The action link type is unspecified. */
	ACTION_LINK_TYPE_UNSPECIFIED = 'ACTION_LINK_TYPE_UNSPECIFIED',
	/** ACTION_LINK_TYPE_BOOK_APPOINTMENT - The action link type is booking an appointment. */
	ACTION_LINK_TYPE_BOOK_APPOINTMENT = 'ACTION_LINK_TYPE_BOOK_APPOINTMENT',
	/** ACTION_LINK_TYPE_BOOK_ONLINE_APPOINTMENT - The action link type is booking an online appointment. */
	ACTION_LINK_TYPE_BOOK_ONLINE_APPOINTMENT = 'ACTION_LINK_TYPE_BOOK_ONLINE_APPOINTMENT',
	/** ACTION_LINK_TYPE_ORDER_FOOD - The action link type is ordering food for delivery or takeout or both. */
	ACTION_LINK_TYPE_ORDER_FOOD = 'ACTION_LINK_TYPE_ORDER_FOOD',
	/** ACTION_LINK_TYPE_ORDER_FOOD_DELIVERY - The action link type is ordering food for delivery. */
	ACTION_LINK_TYPE_ORDER_FOOD_DELIVERY = 'ACTION_LINK_TYPE_ORDER_FOOD_DELIVERY',
	/** ACTION_LINK_TYPE_ORDER_FOOD_TAKEOUT - The action link type is ordering food for takeout. */
	ACTION_LINK_TYPE_ORDER_FOOD_TAKEOUT = 'ACTION_LINK_TYPE_ORDER_FOOD_TAKEOUT',
	/** ACTION_LINK_TYPE_MAKE_DINING_RESERVATION - The action link type is making a dining reservation. */
	ACTION_LINK_TYPE_MAKE_DINING_RESERVATION = 'ACTION_LINK_TYPE_MAKE_DINING_RESERVATION',
	/**
	 * ACTION_LINK_TYPE_SHOP_ONLINE - The action link type allows users to shop from the given merchant. It
	 * could either be delivery or pickup.
	 */
	ACTION_LINK_TYPE_SHOP_ONLINE = 'ACTION_LINK_TYPE_SHOP_ONLINE',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/**
 * Additional information about action link which is unique to the events
 * vertical.
 */
export interface ActionLink_EventMetadata {
	/**
	 * Predetermined event surface associated with an action link. This is only
	 * used for Events vertical.
	 */
	surface?: ActionLink_EventMetadata_Surface | undefined
}

/**
 * Predetermined event surface associated with an action link. This is only
 * used for Events vertical.
 */
export enum ActionLink_EventMetadata_Surface {
	/** SURFACE_UNSPECIFIED - The surface is unspecified. */
	SURFACE_UNSPECIFIED = 'SURFACE_UNSPECIFIED',
	/** SURFACE_SEARCH - The action link is booking a event ticket in Search. */
	SURFACE_SEARCH = 'SURFACE_SEARCH',
	/** SURFACE_YOUTUBE - The action link is booking a event ticket in YouTube. */
	SURFACE_YOUTUBE = 'SURFACE_YOUTUBE',
	/** SURFACE_ADS - The action link is clicking on an Ad for the event. */
	SURFACE_ADS = 'SURFACE_ADS',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/** Metadata for food ordering action links. */
export interface FoodOrderingMetadata {
	/**
	 * Details of fees charged to the user on top of the item total.
	 * Repeated for different types of fees like service fee, delivery fee etc.
	 */
	fee_details?: FoodOrderingMetadata_FeeDetails[] | undefined
	/** Fixed duration. For example: 30 mins. */
	fulfillment_lead_time_duration?: Duration | undefined
	/**
	 * A range of duration.
	 * Examples:
	 * * 30 mins to 45 mins
	 * * Greater than 30 mins
	 * * Less than 50 mins
	 */
	fulfillment_lead_time_duration_range?: DurationRange | undefined
	/**
	 * Details on advanced ordering support also known as order ahead where user
	 * can place an order for fulfillment at a later time than right now.
	 */
	advance_order_details?: FoodOrderingMetadata_AdvanceOrderDetails | undefined
}

/** Fee details. */
export interface FoodOrderingMetadata_FeeDetails {
	type?: FoodOrderingMetadata_FeeDetails_FeeType | undefined
	/**
	 * Fee amount either in unit currency, a percentage of the cart value, or a
	 * combination of both. (required)
	 */
	fee_amount?: FoodOrderingMetadata_FeeDetails_FeeAmount | undefined
}

/** Fee type. */
export enum FoodOrderingMetadata_FeeDetails_FeeType {
	/** FEE_TYPE_UNSPECIFIED - Fee type unspecified. */
	FEE_TYPE_UNSPECIFIED = 'FEE_TYPE_UNSPECIFIED',
	/** DELIVERY - For delivery fees. */
	DELIVERY = 'DELIVERY',
	/** SERVICE - For service fees. */
	SERVICE = 'SERVICE',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/**
 * `FeeAmount` examples:
 *   * Fixed fee: USD 0 (no fee), USD 1.5
 *   * Range of fixed fee: USD 1.0 (minimum), USD 3.0 (maximum), USD 5.0-6.0
 *   * Percentage of cart size: 15.5%, 10%-20%, 10% (minimum), 15% (maximum)
 *   * Compound of range and percentage:
 *       25.5% & USD 2.5 (minimum), 25.5% & USD 4.5 (maximum),
 *       10% & USD 1.5-2.5, 10.5%-20% & USD 2.5-3.5
 */
export interface FoodOrderingMetadata_FeeDetails_FeeAmount {
	/** Fixed amount. For example USD 3.5. */
	amount?: Money | undefined
	/**
	 * Range of amount.
	 * Upper and/or Lower bounds of fee range must be positive.
	 * Examples:
	 *  * USD 3.5 to USD 5.5
	 *  * At least USD 3.5
	 *  * At most USD 5.5
	 */
	amount_range?: MoneyRange | undefined
	/** Unknown amount. */
	amount_unknown?: boolean | undefined
	/**
	 * Fee in terms of a percentage of the cart value.
	 * Supports a range (bounded and unbounded) or a fixed percentage.
	 * Value should be between 0 (exclusive) and 100 (inclusive).
	 * Examples:
	 *  * Fixed 5.5%
	 *  * At least 5.5%
	 *  * At most 5.5%
	 *  * 4.5% to 5.5%
	 */
	cart_percentage?: QuantitativeValue | undefined
}

/** For order ahead support. */
export interface FoodOrderingMetadata_AdvanceOrderDetails {
	/**
	 * True if Advance Orders, also known as Order Ahead, is supported.
	 * (required)
	 */
	is_supported?: boolean | undefined
}

/**
 * Wrapper for a range of duration that can be bounded or unbounded.
 * At least one of min_duration and max_duration duration is required.
 */
export interface DurationRange {
	/** Minimum duration. */
	min_duration?: Duration | undefined
	/** Maximum duration. */
	max_duration?: Duration | undefined
}

/**
 * Fees that must be paid once per order, regardless of number of tickets. These
 * fields must add up to the total per order fee.
 */
export interface PerOrderFee {
	/** A fee that can vary by delivery method. */
	delivery_fee?: Price | undefined
	/** A fee to process the user's payment method. */
	processing_fee?: Price | undefined
}

/**
 * Fees that must be paid for each ticket the user purchases. These fields
 * must add up to the total per ticket fee.
 */
export interface PerTicketFee {
	/** An extra charge assessed for a service. */
	service_charge?: Price | undefined
	/** A fee that goes to the venue/facility. */
	facility_fee?: Price | undefined
	/** Per ticket taxes. */
	taxes?: Price | undefined
}

/** Metadata for an order online action link. */
export interface OrderOnlineMetadata {
	/** Available fulfillment options for an order online action link. */
	fulfillment_option?: FulfillmentOption[] | undefined
}

/** The fulfillment option for an order online action link. */
export interface FulfillmentOption {
	/** Required. The fulfillment type. */
	fulfillment_type?: FulfillmentOption_FulfillmentType | undefined
	/**
	 * Required. A list of days on which there is availability for this
	 * fulfillment method (preferably at least 2).
	 */
	available_day?: FulfillmentOption_AvailableDay[] | undefined
	/** Required. Fee details for the fulfillment method. */
	fee_details?: FulfillmentOption_FeeDetails | undefined
	/**
	 * Required. Minimum order for the fulfillment method associated with the
	 * action link.
	 */
	minimum_order?: Price | undefined
}

/** The fulfillment type associated with an action link. */
export enum FulfillmentOption_FulfillmentType {
	/** FULFILLMENT_TYPE_UNSPECIFIED - The fulfillment type is unspecified. */
	FULFILLMENT_TYPE_UNSPECIFIED = 'FULFILLMENT_TYPE_UNSPECIFIED',
	/** FULFILLMENT_TYPE_DELIVERY - The fulfillment type is delivery. */
	FULFILLMENT_TYPE_DELIVERY = 'FULFILLMENT_TYPE_DELIVERY',
	/** FULFILLMENT_TYPE_PICKUP - The fulfillment type is pickup. */
	FULFILLMENT_TYPE_PICKUP = 'FULFILLMENT_TYPE_PICKUP',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/** Day level availability. */
export interface FulfillmentOption_AvailableDay {
	/**
	 * Required. An available date for a fulfillment method. Assumed to be in
	 * merchant's timezone.
	 */
	fulfillment_date?: DateMessage | undefined
	/**
	 * Required. Unix timestamp. The last time a user could order, and receive
	 * items by `fulfillment_date`. In other words, after last_ordering_time,
	 * fulfillment_date will no longer be shown as available.
	 *
	 * For example, if the fulfillment_date is 2020-08-10:
	 * - a last_ordering_time value of 2020-08-10 18:00 means that, in order to
	 * receive their order on 2020-08-10, a customer must make that order by 6pm
	 * that same day.
	 * - a last_ordering_time value of 2020-08-08 20:00 means that, in order to
	 * receive their order on 2020-08-10, a customer must make that order by 8pm
	 * two days prior.
	 */
	last_ordering_time?: Date | undefined
}

/** No fee required for the fulfillment method associated with the action link. */
export interface FulfillmentOption_NoFee {}

/**
 * The minimum fee required for the fulfillment method associated with the
 * action link.
 */
export interface FulfillmentOption_MinimumFee {
	/** Required. The base fee amount for the fulfillment method. */
	base_fee_amount?: Price | undefined
}

/**
 * The fixed fee required for the fulfillment method associated with the
 * action link.
 */
export interface FulfillmentOption_FixedFee {
	/** Required. The amount of the fixed fee for the fulfillment method. */
	amount?: Price | undefined
}

/** Fee details for the fulfillment method associated with the action link. */
export interface FulfillmentOption_FeeDetails {
	/** No fee for the fulfillment method. */
	no_fee?: FulfillmentOption_NoFee | undefined
	/** The base fee associated with the fulfillment method. */
	base_fee?: FulfillmentOption_MinimumFee | undefined
	/** The fixed fee associated with the fulfillment method. */
	fixed_fee?: FulfillmentOption_FixedFee | undefined
}

/**
 * TicketType is used to differentiate among tickets (where a ticket can be a
 * spot on a raft trip, an admission to a museum, etc.) with different prices
 * and/or availabilities due to different user types or different service
 * attributes.
 * Only add new ticket types when at least one of the following differs:
 *    (1) short_description (2) option_description (3) price
 */
export interface TicketType {
	/**
	 * The ticket id is used to differentiate among different ticket types of the
	 * same service, and is only expected to be unique within a service.
	 */
	ticket_type_id?: string | undefined
	/**
	 * This can be user visible, e.g., “adult”, "child", “veteran”, “Row J”, etc.
	 * Deprecated, use `localized_short_description` instead.
	 *
	 * @deprecated
	 */
	short_description?: string | undefined
	/**
	 * This can be user visible, e.g., “adult”, "child", “veteran”, “Row J”, etc.
	 * The field can be supplied in multiple locales.
	 */
	localized_short_description?: Text | undefined
	/** The price of a single ticket of this type. */
	price?: Price | undefined
	/** Additional fees for purchasing this ticket. (optional) */
	per_ticket_fee?: PerTicketFee | undefined
	/** Predetermined price display type of a single ticket of this type. */
	price_display_type?: TicketType_PriceDisplayType | undefined
	/**
	 * Description of any additional option which this ticket type represents, if
	 * any. Deprecated, use `localized_option_description` instead.
	 *
	 * @deprecated
	 */
	option_description?: string | undefined
	/**
	 * Description of any additional option which this ticket type represents, if
	 * any. The field can be supplied in multiple locales.
	 *
	 * This is useful when the ticket type represents multiple dimensions.
	 *
	 * Example: an admission ticket with different types 'adult', 'child' and
	 * language as an additional option, the expected TicketType list would be:
	 *     - { ticket_type_id: "ticket_type_1"
	 *         localized_short_description { value: "adult" }
	 *         localized_option_description { value: "english" }
	 *       }
	 *     - { ticket_type_id: "ticket_type_2"
	 *         localized_short_description { value: "adult" }
	 *         localized_option_description { value: "spanish" }
	 *       }
	 *     - { ticket_type_id: "ticket_type_3"
	 *         localized_short_description { value: "child" }
	 *         localized_option_description { value: "english" }
	 *       }
	 *     - { ticket_type_id: "ticket_type_4"
	 *         localized_short_description { value: "child" }
	 *         localized_option_description { value: "spanish" }
	 *       }
	 *
	 * Optional, but if any ticket type within the service has this field set, we
	 * expect all other ticket types to have this field set as well (a default
	 * option_description could be used). E.g.
	 * [{ticket_type_1, adult, english}, {ticket_type_1, adult, ''}] is not a
	 * valid list.
	 *
	 * Only two HTML formatting tags are supported: <em> and <br>. They are
	 * intended to be used for specifying options with both a title and
	 * detailed description, for example: "<em>Premium Seating</em><br>This option
	 * offers seating at the private boxes including fully cushioned seats,
	 * private TVs, in-seat food and beverage service. These seats provide
	 * picturesque views of the field."
	 */
	localized_option_description?: Text | undefined
	/** Predetermined inventory type of a single ticket of this type. */
	inventory_type?: TicketType_InventoryType | undefined
}

/**
 * Indicates the price format displayed on the landing page.
 *
 * This field is ignored for non-link-out inventory.
 *
 * This field allows Google surfaces to show the same price format as used by
 * the landing page. Consistent price formats improve conversion rate and
 * reduce confusion.
 */
export enum TicketType_PriceDisplayType {
	/**
	 * PRICE_DISPLAY_TYPE_UNSPECIFIED - The price display type is unspecified. Google will determine which
	 * format to show.
	 */
	PRICE_DISPLAY_TYPE_UNSPECIFIED = 'PRICE_DISPLAY_TYPE_UNSPECIFIED',
	/** PRICE_DISPLAY_TYPE_BASE - The price shown on the landing page is the base price. */
	PRICE_DISPLAY_TYPE_BASE = 'PRICE_DISPLAY_TYPE_BASE',
	/** PRICE_DISPLAY_TYPE_ALL_IN - The price shown on the landing page includes all fees and taxes. */
	PRICE_DISPLAY_TYPE_ALL_IN = 'PRICE_DISPLAY_TYPE_ALL_IN',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/** Predetermined inventory type of a single ticket of this type. */
export enum TicketType_InventoryType {
	/** INVENTORY_TYPE_UNSPECIFIED - The inventory type is unspecified. */
	INVENTORY_TYPE_UNSPECIFIED = 'INVENTORY_TYPE_UNSPECIFIED',
	/** INVENTORY_TYPE_PRIMARY - Primary inventory. */
	INVENTORY_TYPE_PRIMARY = 'INVENTORY_TYPE_PRIMARY',
	/** INVENTORY_TYPE_VERIFIED_RESALE - Verified resale inventory. */
	INVENTORY_TYPE_VERIFIED_RESALE = 'INVENTORY_TYPE_VERIFIED_RESALE',
	/** INVENTORY_TYPE_RESALE - Resale inventory. */
	INVENTORY_TYPE_RESALE = 'INVENTORY_TYPE_RESALE',
	/** INVENTORY_TYPE_AGGREGATOR - Aggregator inventory. */
	INVENTORY_TYPE_AGGREGATOR = 'INVENTORY_TYPE_AGGREGATOR',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/** Geographic information about a location. */
export interface Location {
	/**
	 * The Place ID for a place in the Google Places database and on Google Maps.
	 * See https://developers.google.com/places/place-id for more about Place IDs.
	 * If this is provided, Google will match the location to this place.
	 * (optional)
	 */
	place_id?: string | undefined
	/**
	 * The location's name, telephone, url and geo are used to support matching
	 * the location with places already present on Google Maps.
	 *
	 * This field is optional, but may be required in some contexts. For example,
	 * a Service.location without a name will not be matched to a business entity,
	 * even if they are located at the same address. (optional)
	 */
	name?: string | undefined
	/**
	 * The public telephone number of the location including its country and area
	 * codes, e.g. +14567891234. (optional)
	 */
	telephone?: string | undefined
	/** The url of the location's public website. (optional) */
	url?: string | undefined
	/**
	 * The Geo info of the location, including latitude, longitude, and address.
	 * (optional)
	 */
	geo?: GeoCoordinates | undefined
	/**
	 * Optional text to provide more precise description of the location, or
	 * instructions assisting locating the place. E.g. "Front entrance of the
	 * library", "meet at the intersect of Road A and Street B". (optional)
	 */
	description?: Text | undefined
	/**
	 * The type of the location. Note that this field may be required when
	 * attached to a Service, see comments in Service.location for more details.
	 * (optional)
	 */
	location_type?: LocationType | undefined
	/**
	 * Unique reference of the location within the service. This id can be used to
	 * refer to this location in other service fields. E.g. in the custom intake
	 * form, a set of location ids can be used to specify pick up location
	 * options. If set, this id should be unique within the same service.
	 * Note this is only applicable for Service.
	 * (optional)
	 */
	location_id?: string | undefined
}

/** Cancellation policy for a service. */
export interface CancellationPolicy {
	/** Zero or more refund conditions applicable to the policy. */
	refund_condition?: CancellationPolicy_RefundCondition[] | undefined
}

/**
 * Defines a single refund condition. Multiple refund conditions could be
 * used together to describe "refund steps" as various durations before the
 * service start time.
 */
export interface CancellationPolicy_RefundCondition {
	/**
	 * Duration in seconds before the start time, until when the customer can
	 * receive a refund for part of the service's cost specified in
	 * `refund_percent`.
	 * When set to 0 (default), the service can be cancelled at any time.
	 */
	min_duration_before_start_time_sec?: string | undefined
	/**
	 * The percent that can be refunded, as long as the service booking is
	 * cancelled at least `min_duration_before_start_time` before the service
	 * start time, in the range of [0, 100]. When set to 0 (default), the
	 * service is not refundable. When set to 100 this service is fully
	 * refundable.
	 */
	refund_percent?: number | undefined
}

/**
 * Photos related to this service. Google will crawl these media to ensure
 * that they are displayed correctly to end-users. (optional)
 */
export interface RelatedMedia {
	/** URL of this media source. Google will crawl the media hosted at this URL. */
	url?: string | undefined
	/** Type of this media source. */
	type?: RelatedMedia_MediaType | undefined
	/**
	 * Caption of the media that supports i18n, only plain text is supported. Any
	 * HTML components will be stripped. (optional)
	 */
	localized_caption?: Text | undefined
	/**
	 * Attribution information about the source of the media. Note that if
	 * the attribution is required to display with the media to give credit to
	 * photographer or agency, this field must be set. (optional)
	 */
	attribution?: RelatedMedia_Attribution | undefined
	/**
	 * Deprecated, prefer to use localized_caption.
	 *
	 * @deprecated
	 */
	caption?: string | undefined
}

/**
 * Enum to indicate the type of this media source. Only photos are supported.
 * Please reach out to the Reserve with Google team if other media beyond
 * photos need to be supported.
 */
export enum RelatedMedia_MediaType {
	/** TYPE_UNSPECIFIED - Unused. */
	TYPE_UNSPECIFIED = 'TYPE_UNSPECIFIED',
	/** PHOTO - Indicates the media provided by the url is a photo. */
	PHOTO = 'PHOTO',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/** Attribution information for this media. */
export interface RelatedMedia_Attribution {
	/**
	 * The text to give credit to the photographer or agency supporting i18n.
	 * This text will be displayed together with the source media. Note that
	 * only plain text is supported for this field, any HTML components will be
	 * stripped (hyperlink based attribution is not supported).
	 */
	localized_text?: Text | undefined
	/**
	 * Deprecated, prefer to use localized_text.
	 *
	 * @deprecated
	 */
	text?: string | undefined
}

/**
 * Identifies a particular value of a service attribute to be applied to a
 * Service.
 */
export interface ServiceAttributeValueId {
	/**
	 * ID of an attribute as defined in Merchant.service_attribute, e.g.
	 * "service-type".
	 */
	attribute_id?: string | undefined
	/**
	 * ID of the value for this attribute, e.g. "haircut". Must match a value_id
	 * in the service attribute definition.
	 */
	value_id?: string | undefined
}

/** Rules related to joining the waitlist. */
export interface WaitlistRules {
	/**
	 * Required. Must be a positive integer for services providing waitlist
	 * functionality. If the service or merchant does not provide waitlist
	 * functionality, this must not be populated.
	 */
	min_party_size?: number | undefined
	/**
	 * Required. Must be a positive integer for services providing waitlist
	 * functionality. If the service or merchant does not provide waitlist
	 * functionality, this must not be populated.
	 */
	max_party_size?: number | undefined
	/**
	 * If true, the user will be able to send a free-form additional text request
	 * when joining the waitlist for this service.
	 */
	supports_additional_request?: boolean | undefined
	/**
	 * Set options for parties larger than the set max_party_size.
	 * Leave empty if larger parties should not be given alternative options
	 * for joining a waitlist.
	 */
	above_max_party_size_options?: UnsupportedPartySizeOption[] | undefined
}

/** Options for parties that are out of range. */
export interface UnsupportedPartySizeOption {
	/**
	 * Party sizes that are out of range can call the business.
	 * A predefined message will be displayed to the user.
	 * Sample text to be displayed: "For parties larger than
	 * {waitlist_rules.max_party_size} please call the restaurant at
	 * {restaurant phone number in Google maps}." CallMerchant must be
	 * set, but will be empty.
	 */
	call_merchant?: CallMerchant | undefined
}

/**
 * Empty message to be used in UnsupportedPartySizeOption, setting this will
 * display a pre-defined message to users to call the business for a booking.
 */
export interface CallMerchant {}

/** Additional information unique to the event ticketing vertical. */
export interface TicketingVerticalSpecificData {
	/**
	 * The category of the event. Set only when event falls into one of the
	 * predefined categories. (optional)
	 */
	event_category?: TicketingVerticalSpecificData_EventCategory | undefined
	/** The URL of the event on the partner's website. (optional) */
	event_url?: string | undefined
	/** A list of entities related to the event. (optional) */
	entity?: TicketingVerticalSpecificData_Entity[] | undefined
	/** Required. The type of the event attendance. */
	event_attendance_mode?: TicketingVerticalSpecificData_AttendanceMode | undefined
	/** Optional. URL where the event can be watched. */
	event_virtual_location_url?: string[] | undefined
	/** Optional. Organizer who hosts the event. */
	event_organizer?: Text | undefined
	/** Optional. URL of the organizer who hosts the event. */
	event_organizer_url?: string | undefined
	/** Optional. The type of the organizer. */
	event_organizer_type?: TicketingVerticalSpecificData_OrganizerType | undefined
	/**
	 * URL of the pages where the event information or descriptions can be found.
	 * Required for virtual events as virtual events may not have a ticketing
	 * page and this url contains the basic information of the event.
	 */
	event_source_url?: string[] | undefined
	/** Optional. State of the event. */
	event_state?: TicketingVerticalSpecificData_EventState | undefined
	/** The localized brand name. (optional) */
	brand_name?: Text | undefined
	/** Information about the creator of the event. */
	event_creator?: TicketingVerticalSpecificData_EventCreator | undefined
}

/**
 * A subset of event categories for which we customize the product experience.
 * Note: not intended to be a universal ontology of events.
 */
export enum TicketingVerticalSpecificData_EventCategory {
	/** EVENT_CATEGORY_UNSPECIFIED - Not specified. Do not use. */
	EVENT_CATEGORY_UNSPECIFIED = 'EVENT_CATEGORY_UNSPECIFIED',
	/** EVENT_CATEGORY_CONCERT - Concerts. */
	EVENT_CATEGORY_CONCERT = 'EVENT_CATEGORY_CONCERT',
	/** EVENT_CATEGORY_SPORTS - Sports events. */
	EVENT_CATEGORY_SPORTS = 'EVENT_CATEGORY_SPORTS',
	/** EVENT_CATEGORY_THEATRE - Theatre events. */
	EVENT_CATEGORY_THEATRE = 'EVENT_CATEGORY_THEATRE',
	/** EVENT_CATEGORY_EXHIBITS - Exhibits. */
	EVENT_CATEGORY_EXHIBITS = 'EVENT_CATEGORY_EXHIBITS',
	/** EVENT_CATEGORY_WORKSHOPS_AND_CLASSES - Workshops and Classes. */
	EVENT_CATEGORY_WORKSHOPS_AND_CLASSES = 'EVENT_CATEGORY_WORKSHOPS_AND_CLASSES',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/** The type of the event attendance. */
export enum TicketingVerticalSpecificData_AttendanceMode {
	/** ATTENDANCE_MODE_UNSPECIFIED - Not specified. */
	ATTENDANCE_MODE_UNSPECIFIED = 'ATTENDANCE_MODE_UNSPECIFIED',
	/** ONLINE - For virtual events. */
	ONLINE = 'ONLINE',
	/** PHYSICAL - For physical events. */
	PHYSICAL = 'PHYSICAL',
	/** PHYSICAL_ONLINE_MIXED - For events that are both physical and virtual. */
	PHYSICAL_ONLINE_MIXED = 'PHYSICAL_ONLINE_MIXED',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/** The type of the organizer. */
export enum TicketingVerticalSpecificData_OrganizerType {
	/** ORGANIZER_TYPE_UNSPECIFIED - Not specified. */
	ORGANIZER_TYPE_UNSPECIFIED = 'ORGANIZER_TYPE_UNSPECIFIED',
	/** PERSON - For organizer who is a person. */
	PERSON = 'PERSON',
	/** ORGANIZATION - For organizer who is an organization. */
	ORGANIZATION = 'ORGANIZATION',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/** State of the event. */
export enum TicketingVerticalSpecificData_EventState {
	/** EVENT_STATE_UNSPECIFIED - Not specified. */
	EVENT_STATE_UNSPECIFIED = 'EVENT_STATE_UNSPECIFIED',
	/** SCHEDULED - The event is scheduled. */
	SCHEDULED = 'SCHEDULED',
	/** RESCHEDULED - The event is rescheduled. */
	RESCHEDULED = 'RESCHEDULED',
	/** CANCELLED - The event is cancelled. */
	CANCELLED = 'CANCELLED',
	/** POSTPONED - The event is postponed. */
	POSTPONED = 'POSTPONED',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/**
 * Identifiers, webpages, or any other public sources that reference an
 * entity.
 */
export interface TicketingVerticalSpecificData_PublicIdentificationData {
	/**
	 * Public URL of any webpage that is dedicated to only the topic. This could
	 * include official websites, discogs, social media platforms, wikipedia or
	 * imdb pages, e.g. https://www.discogs.com/artist/1124645-Taylor-Swift,
	 * https://www.wikidata.org/wiki/Q19320959, https://twitter.com/acmilan.
	 * (optional)
	 */
	relevant_url?: string[] | undefined
	/**
	 * The 36-character musicbrainz identifier of the artist or other music
	 * entities, if applicable. See
	 * https://musicbrainz.org/doc/MusicBrainz_Identifier.
	 * (optional)
	 */
	musicbrainz_id?: string | undefined
}

/** Represents an entity related to the event. */
export interface TicketingVerticalSpecificData_Entity {
	/** Unique identifier of the entity in the partner's database. (optional) */
	id?: string | undefined
	/** Name of the entity. (required) */
	name?: string | undefined
	/**
	 * Url of the webpage that unambiguously describes the entity.
	 * This is the webpage on the partner's website for the entity if any; for
	 * other public URLs of the entity, use relevant_url in
	 * public_identification_data. (optional)
	 */
	url?: string | undefined
	/** The type of the entity. (optional) */
	entity_type?: TicketingVerticalSpecificData_Entity_EntityType | undefined
	/** The role of the entity in the event. (optional) */
	entity_role?: TicketingVerticalSpecificData_Entity_EntityRole | undefined
	/** Public references of the entity. (optional) */
	public_identification_data?: TicketingVerticalSpecificData_PublicIdentificationData | undefined
}

/** The type of the entity. Note: not intended to be a universal ontology. */
export enum TicketingVerticalSpecificData_Entity_EntityType {
	/** ENTITY_TYPE_UNSPECIFIED - Not specified. Do not use. */
	ENTITY_TYPE_UNSPECIFIED = 'ENTITY_TYPE_UNSPECIFIED',
	/**
	 * ENTITY_TYPE_PERFORMER - The entity represents the artist or group performing at a
	 * concert or a show. Only applicable when event category is CONCERT or
	 * THEATRE.
	 */
	ENTITY_TYPE_PERFORMER = 'ENTITY_TYPE_PERFORMER',
	/**
	 * ENTITY_TYPE_PLAYER - The entity represents the sports team or player at the event. Only
	 * applicable when event category is SPORTS.
	 */
	ENTITY_TYPE_PLAYER = 'ENTITY_TYPE_PLAYER',
	/**
	 * ENTITY_TYPE_CONCERT_TOUR - The entity represents the tour that this event belongs to. Only
	 * applicable when event category is CONCERT.
	 */
	ENTITY_TYPE_CONCERT_TOUR = 'ENTITY_TYPE_CONCERT_TOUR',
	/**
	 * ENTITY_TYPE_SPORTS_SERIES - The entity represents a sports tournament that this event
	 * belongs to. Only applicable when event category is SPORTS.
	 */
	ENTITY_TYPE_SPORTS_SERIES = 'ENTITY_TYPE_SPORTS_SERIES',
	/**
	 * ENTITY_TYPE_PLAY - The entity represents the type of play (e.g., musical, comedy, ballet,
	 * etc.) performed at the event. Only applicable when event category is
	 * THEATRE.
	 */
	ENTITY_TYPE_PLAY = 'ENTITY_TYPE_PLAY',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/** The role of the entity in the event. */
export enum TicketingVerticalSpecificData_Entity_EntityRole {
	/** ENTITY_ROLE_UNSPECIFIED - Not specified. */
	ENTITY_ROLE_UNSPECIFIED = 'ENTITY_ROLE_UNSPECIFIED',
	/** ENTITY_ROLE_HEADLINER - The entity represents a headliner or leading performer at the event. */
	ENTITY_ROLE_HEADLINER = 'ENTITY_ROLE_HEADLINER',
	/** ENTITY_ROLE_SUPPORTER - The entity represents a supporting performer at the event. */
	ENTITY_ROLE_SUPPORTER = 'ENTITY_ROLE_SUPPORTER',
	/** ENTITY_ROLE_HOME_TEAM - The entity represents the home team at the (sports) event. */
	ENTITY_ROLE_HOME_TEAM = 'ENTITY_ROLE_HOME_TEAM',
	/** ENTITY_ROLE_AWAY_TEAM - The entity represents the away team at the (sports) event. */
	ENTITY_ROLE_AWAY_TEAM = 'ENTITY_ROLE_AWAY_TEAM',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/**
 * Information about the creator of the event. Only relevant for platforms
 * that include user-generated content events.
 */
export interface TicketingVerticalSpecificData_EventCreator {
	/** Name of the event creator. No character restriction. */
	name?: string | undefined
}

/**
 * Content fields specific to Tours and Activities. Each element in the repeated
 * field should be independent to allow separate rendering (e.g. as a bullet
 * point).
 *
 * Populating ToursAndActivitiesContent is strongly recommended for tours and
 * activities, but not strictly required. All fields support both plain-text
 * and HTML-like text for basic formatting. Supported HTML-like formatting tags:
 *
 * Phrase tags: <br>, <strong>, <em>, <i>:
 *   Only the four tags mentioned above are supported. <br> can be used to
 *   break lines in paragraphs, and <strong>/<em> can be used to highlight
 *   important text. Any other phrase tags will be ignored.
 *
 * All other tags and custom styles are not allowed and will be removed. Any
 * URLs, anchors, and links will be stripped, and will never be displayed to
 * end-users.
 *
 * Important notes:
 *   * Don't duplicate data already supplied in `highlights`, `exclusion` and
 *     other, more specific, fields in service description.
 *   * Avoid using other tags except for the supported ones mentioned above,
 *     because the contents within unsupported tags will be stripped, and may
 *     lead to an undesirable user experience.
 */
export interface ToursAndActivitiesContent {
	/** The user-visible list of highlights. */
	highlights?: Text[] | undefined
	/** The user-visible list of inclusions. */
	inclusions?: Text[] | undefined
	/** The user-visible list of exclusions. */
	exclusions?: Text[] | undefined
	/**
	 * The user-visible list of important notes, use for details such as age
	 * restrictions or other conditions that make this service unsuitable.
	 */
	must_know?: Text[] | undefined
}

/**
 * Information about virtual/online session. E.g. Online yoga class, virtual
 * cooking class etc.
 */
export interface VirtualSession {
	/**
	 * Instructions on how this virtual class is set up. If the partner does not
	 * include the video URL with the booking, then this text must include when
	 * the video URL will be shared with the user. Eg. “Zoom url will be mailed
	 * 30 minutes prior to the class”. (Recommended)
	 * Only the folloiwng four tags are supported: <br>, <strong>, <em>, <i>.
	 */
	session_instructions?: Text | undefined
	/**
	 * Requirements for the given virtual session. Eg. yoga mat,
	 * cooking utensils etc. (Recommended)
	 * Only the folloiwng four tags are supported: <br>, <strong>, <em>, <i>.
	 */
	session_requirements?: Text | undefined
	virtual_platform_info?: VirtualSession_VirtualPlatformInfo | undefined
	/**
	 * Set this as true if the virtual session is not live and is pre-recorded.
	 * (Optional)
	 */
	is_session_prerecorded?: boolean | undefined
}

/**
 * Information about the virtual platform used in this session. (Required to
 * enable virtual services)
 */
export interface VirtualSession_VirtualPlatformInfo {
	platform?: VirtualSession_VirtualPlatformInfo_Platform | undefined
	/**
	 * The name of the platform if the platform is set to OTHER. (Required if
	 * platform is set to OTHER)
	 */
	other_platform_name?: Text | undefined
}

/** Enum to indicate which virtual platform would be used by the merchant. */
export enum VirtualSession_VirtualPlatformInfo_Platform {
	PLATFORM_UNSPECIFIED = 'PLATFORM_UNSPECIFIED',
	/** FLEXIBLE - The merchant is flexible in which video platform they use. */
	FLEXIBLE = 'FLEXIBLE',
	GOOGLE_HANGOUTS = 'GOOGLE_HANGOUTS',
	GOOGLE_MEET = 'GOOGLE_MEET',
	ZOOM = 'ZOOM',
	SKYPE = 'SKYPE',
	YOUTUBE = 'YOUTUBE',
	/**
	 * OTHER - Should be set if the video platform used is different from the ones
	 * mentioned here.
	 */
	OTHER = 'OTHER',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/**
 * Information about how the user can pay directly to the merchant instead of
 * pre-paying for the service via RwG.
 */
export interface DirectMerchantPayment {
	/** Users would be advised to pay only via the payment methods mentioned below. */
	payment_methods?: Text[] | undefined
}

/** Defines Rating for an entity. */
export interface Rating {
	/**
	 * Average rating value (required when number_of_ratings > 0).
	 * The value must be in the range of [1, 5] and can be omitted if and only if
	 * the number_of_ratings is zero.
	 */
	value?: number | undefined
	/** Number of ratings used in calculating the value (required). */
	number_of_ratings?: string | undefined
}

/** Additional information required to be provided for home service vertical. */
export interface HomeServiceData {
	/**
	 * The high level category to which this home service belongs to. E.g.
	 * plumber, electrician etc.
	 */
	category_type?: string | undefined
	/**
	 * The job type under the category to which the given home service belongs to.
	 * E.g. unclog_drain, install_faucet are the job types under plumber
	 * category.
	 */
	job_type?: string | undefined
}

/** Ranking hints for a service. */
export interface ServiceRankingHint {
	/**
	 * Arbitrary partner or merchant assigned rank for this service.
	 *
	 * Services with a higher score will be shown more prominently (e.g. shown
	 * higher in lists). Note that other factors may also influence ranking, such
	 * as price, availability, user history, etc.
	 *
	 * Optional. Must be non-negative if set.
	 */
	score?: number | undefined
}

export interface AvailabilityFeed {
	metadata?: FeedMetadata | undefined
	service_availability?: ServiceAvailability[] | undefined
}

export interface ServiceAvailability {
	/**
	 * If provided, we will consider the Availability entities provided to be a
	 * complete snapshot from [start_timestamp_restrict, end_timestamp_restrict).
	 * That is, all existing availability will be deleted if the following
	 * condition holds true:
	 *
	 *    start_timestamp_restrict <= Availability.start_sec &&
	 *    Availability.start_sec < end_timestamp_restrict
	 *
	 * If a duration message is set, the condition is further restricted:
	 *   Availability.duration == duration_restrict_sec
	 *
	 * If a resource_restrict message is set, the condition is further restricted:
	 *
	 *    Availability.resource.staff_id == resource_restrict.staff_id &&
	 *    Availability.resource.room_id == resource_restrict.room_id
	 *
	 * These fields are typically used to provide a complete update of
	 * availability in a given time range.
	 *
	 * Setting start_timestamp_restrict while leaving end_timestamp_restrict unset
	 * is interpreted to mean all time beginning at start_timestamp_restrict.
	 *
	 * Setting end_timestamp_restrict while leaving start_timestamp_restrict unset
	 * is interpreted to mean all time up to the end_timestamp_restrict.
	 *
	 * In Unix time format (seconds since the epoch) from UTC. (both optional)
	 */
	start_timestamp_restrict?: string | undefined
	end_timestamp_restrict?: string | undefined
	/**
	 * If provided, the timestamp restricts will be applied only to the given
	 * merchant or service.
	 *
	 * These fields are typically used to provide complete snapshot of
	 * availability in a given range (defined above) for a specific merchant or
	 * service.
	 *
	 * Leaving these fields unset, or setting these to the empty string or null,
	 * is interpreted to mean that no restrict is intended. (both optional)
	 */
	merchant_id_restrict?: string | undefined
	service_id_restrict?: string | undefined
	/**
	 * Setting duration further restricts the scope of the update to just the
	 * availability with matching duration.
	 *
	 * In seconds. (optional)
	 */
	duration_restrict_sec?: string | undefined
	/**
	 * Setting resources_restrict further restricts the scope of the update to
	 * just this set of resources. All id fields of the resources must match
	 * exactly. (optional)
	 */
	resources_restrict?: Resources | undefined
	/** All Availability Slots included in this Service Availability (required) */
	availability?: Availability[] | undefined
}

/**
 * An availability of the merchant's service, indicating time and number
 * of spots.
 * The availability feed should be a list of this message.
 * Please note that it's up to the partner to call out all the possible
 * availabilities.
 * If a massage therapist is available 9am-12pm, and they provide
 * one-hour massage sessions, the aggregator should provide the feed as
 *   availability {start_sec: 9am, duration: 60 minutes, ...}
 *   availability {start_sec: 10am, duration: 60 minutes, ...}
 *   availability {start_sec: 11am, duration: 60 minutes, ...}
 * instead of
 *   availability {start_sec: 9am, duration: 180 minutes, ...}
 */
export interface Availability {
	/** An opaque string from an aggregator to identify a merchant. (required) */
	merchant_id?: string | undefined
	/**
	 * An opaque string from aggregator to identify a service of the
	 * merchant. (required)
	 */
	service_id?: string | undefined
	/**
	 * Start time of this availability, using epoch time in seconds in UTC.
	 * (required)
	 */
	start_sec?: string | undefined
	/**
	 * Duration of the service in seconds, e.g. 30 minutes for a chair massage.
	 * (required)
	 */
	duration_sec?: string | undefined
	/**
	 * Number of total spots and open spots of this availability.
	 * E.g. a Yoga class of 10 spots with 3 booked.
	 *   availability {spots_total: 10, spots_open: 7 ...}
	 * E.g. a chair massage session which was already booked.
	 *   availability {spots_total: 1, spots_open: 0 ...}
	 *
	 * Note: If sending requests using the availability compression format defined
	 *       below, these two fields will be inferred. A Recurrence
	 *       implies spots_total=1 and spots_open=1. A ScheduleException implies
	 *       spots_total=1 and spots_open=0.
	 * (both required if recurrence not set)
	 */
	spots_total?: string | undefined
	spots_open?: string | undefined
	/**
	 * An optional opaque string to identify this availability slot. If set, it
	 * will be included in the requests that book/update/cancel appointments.
	 * (optional)
	 */
	availability_tag?: string | undefined
	/**
	 * Optional resources used to disambiguate this availability slot from
	 * others when different staff, room, or party_size values are part
	 * of the service.
	 *
	 * E.g. the same Yoga class with two 2 instructors.
	 *  availability { resources { staff_id: "1" staff_name: "Amy" }
	 *                 spots_total: 10 spots_open: 7 }
	 *  availability { resources { staff_id: "2" staff_name: "John" }
	 *                 spots_total: 5 spots_open: 2 }
	 * (optional)
	 */
	resources?: Resources | undefined
	/**
	 * A list of IDs referencing the payment options which can be used to pay
	 * for this slot. The actual payment options are defined at the Merchant
	 * level, and can also be shared among multiple Merchants.
	 *
	 * This field overrides any payment_option_ids specified in the service
	 * message. Similarly payment_option_ids specified here do NOT have to be
	 * present in the service message, though must be defined at the
	 * Merchant level.
	 * Our current implementation limits the number of entries in this array to
	 * one element. Multiple payment_option_id are still allowed at the Service
	 * level, but an override at the availability slot level, is limited to a
	 * single payment_option_id. (optional)
	 */
	payment_option_id?: string[] | undefined
	/**
	 * The recurrence information for the availability, representing more than one
	 * start time. A recurrence should contain appointments for one working day.
	 * (optional)
	 */
	recurrence?: Availability_Recurrence | undefined
	/**
	 * Times when this service cannot be scheduled. To limit the number of
	 * schedule_exception messages, consider joining adjacent exceptions.
	 * (optional)
	 */
	schedule_exception?: Availability_ScheduleException[] | undefined
	/**
	 * Defines how a deposit may be charged to the user. Overrides the service
	 * deposit if one was specified. Setting this to an empty Deposit message
	 * removes any service-level deposit. (optional)
	 */
	deposit?: Deposit | undefined
	/**
	 * Defines a no show fee that may be charged to the user. Overrides the
	 * service no show fee if one was specified. Setting this to an empty
	 * NoShowFee message removes any service-level no show fee. (optional)
	 */
	no_show_fee?: NoShowFee | undefined
	/**
	 * Optional prepayment information for this availability. Prepayment is only
	 * available through the Payment Redirect Add-on
	 */
	prepayment?: Prepayment | undefined
	/**
	 * Indicates whether the user must provide a credit card in order to book this
	 * availability slot.
	 * If the value is not set, it is inherited from the service level if it's set
	 * there. (optional)
	 */
	require_credit_card?: RequireCreditCard | undefined
	/**
	 * Availability scheduling rules. If fields are populated, they will override
	 * any corresponding scheduling rules on the service-level SchedulingRules.
	 */
	scheduling_rule_overrides?: Availability_SchedulingRuleOverrides | undefined
	/**
	 * The requirement to show the slots duration and/or endtime.
	 * This field will be ignored if the slot is unavailable. Not used in the
	 * Things-To-Do vertical. (optional)
	 */
	duration_requirement?: Availability_DurationRequirement | undefined
	/**
	 * The confirmation mode that will be used when booking this availability.
	 * Attempts to create bookings for availabilities with a confirmation mode
	 * of CONFIRMATION_MODE_SYNCHRONOUS must be immediatlely confirmed or denied.
	 * Attempts to create bookings for availabilities with confirmation mode
	 * of CONFIRMATION_MODE_ASYNCHRONOUS must be either immediately denied
	 * or created with status PENDING. Populating confirmation_mode is strongly
	 * recommended, but not strictly required. (optional)
	 */
	confirmation_mode?: Availability_ConfirmationMode | undefined
	/**
	 * The reason a linkout is required for this slot. If set, the Merchant
	 * resource for this slot must have a valid LinkoutTemplate.
	 */
	linkout_required_reason?: Availability_LinkoutRequiredReason | undefined
}

/**
 * This enum indicates what requirements exist for the user to
 * acknowledge or view the requested slots duration/end time.
 */
export enum Availability_DurationRequirement {
	/** DURATION_REQUIREMENT_UNSPECIFIED - The handling of the end time is not specified. This is the default. */
	DURATION_REQUIREMENT_UNSPECIFIED = 'DURATION_REQUIREMENT_UNSPECIFIED',
	/** DO_NOT_SHOW_DURATION - The end time is not shown to the user. */
	DO_NOT_SHOW_DURATION = 'DO_NOT_SHOW_DURATION',
	/**
	 * MUST_SHOW_DURATION - The end time has to be shown to the user before an appointment can be
	 * made.
	 */
	MUST_SHOW_DURATION = 'MUST_SHOW_DURATION',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/** The confirmation modes used when booking availabilities. */
export enum Availability_ConfirmationMode {
	/**
	 * CONFIRMATION_MODE_UNSPECIFIED - The confirmation mode was not specified.
	 * Synchronous confirmation will be assumed.
	 */
	CONFIRMATION_MODE_UNSPECIFIED = 'CONFIRMATION_MODE_UNSPECIFIED',
	/** CONFIRMATION_MODE_SYNCHRONOUS - Bookings for this availability will be confirmed synchronously. */
	CONFIRMATION_MODE_SYNCHRONOUS = 'CONFIRMATION_MODE_SYNCHRONOUS',
	/** CONFIRMATION_MODE_ASYNCHRONOUS - Bookings for this availability will be confirmed asynchronously. */
	CONFIRMATION_MODE_ASYNCHRONOUS = 'CONFIRMATION_MODE_ASYNCHRONOUS',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/**
 * The reason why a slot requires a linkout. Currently only used for Dining
 * Reservations Payment Redirect Partners.
 */
export enum Availability_LinkoutRequiredReason {
	/** LINKOUT_REQUIRED_REASON_UNSPECIFIED - Default value: Do not use, equates to unknown. */
	LINKOUT_REQUIRED_REASON_UNSPECIFIED = 'LINKOUT_REQUIRED_REASON_UNSPECIFIED',
	/** PAYMENT_REQUIRED - Slot requires payment in the partner platform to be booked. */
	PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
	UNRECOGNIZED = 'UNRECOGNIZED',
}

/**
 * Recurrence messages are optional, but allow for a more compact
 * representation of consistently repeating availability slots. They typically
 * represent a day's working schedule.
 * ScheduleException messages are then used to represent booked/unavailable
 * time ranges within the work day.
 *
 * Requirements:
 *   1. The expansion of availability slots or recurrences must NOT create
 *      identical slots. If the ids, start_sec, duration_sec, and resources
 *      match, slots are considered identical.
 *   2. Do NOT mix the standard availability format and recurrence within the
 *      slots of a single service. Recurrence benefits merchants/services that
 *      offer appointments. The standard format is geared towards
 *      merchants/services with regularly scheduled classes.
 */
export interface Availability_Recurrence {
	/**
	 * The inclusive maximum UTC timestamp the availability repeats until.
	 * (required)
	 */
	repeat_until_sec?: string | undefined
	/**
	 * Defines the time between successive availability slots.
	 *
	 * Example: An availability with a duration of 20 min, a repeat_every_sec of
	 * 30 min, a start_sec of 9:00am, and a repeat_until_sec of 11:00am will
	 * yield slots at 9-9:20am, 9:30-9:50am, 10-10:20am, 10:30-10:50am,
	 * 11-11:20am. (required)
	 */
	repeat_every_sec?: number | undefined
}

/**
 * ScheduleException messages represent booked/unavailable time ranges within
 * the workday, which are exceptions to the recurrence described above. As
 * time slots are booked, the list of exceptions should be updated to reflect
 * the newly unavailable time ranges. The recurrence itself shouldn't be
 * modified.
 */
export interface Availability_ScheduleException {
	/**
	 * The time range of the exception. Any slots described by the recurrence
	 * which overlap this closed-open time range will be considered unavailable.
	 *
	 * Example: If the recurrence specifies a duration of 20 min, a
	 * repeat_every_sec of 30 min, a start_time of 9:00am, and a
	 * repeat_until_sec of 11:00am, then a ScheduleException with a time_range
	 * of 9:45am-11:00am would make unavailable the slots at 9:30-9:50am,
	 * 10-10:20am, and 10:30-10:50am.
	 *
	 * Note that because the time range is closed-open, the slot beginning at
	 * 11am slot would not be impacted.
	 */
	time_range?: TimeRange | undefined
}

/** Availability level scheduling rules. */
export interface Availability_SchedulingRuleOverrides {
	/**
	 * The last time (in seconds) that this slot is able to be booked. This
	 * timestamp must be before the start_sec of the slot to be respected
	 * (if users should be able to book after the start time, use service level
	 * SchedulingRules.min_booking_buffer_before_end_time). If present, will
	 * override anything specified in the min_booking_buffer of the
	 * corresponding Service's SchedulingRules.
	 */
	last_bookable_sec?: string | undefined
	/** The first time (in seconds) that this slot is able to be booked. */
	first_bookable_sec?: string | undefined
	/**
	 * If set, the last time (in seconds since the Unix epoch) that this
	 * specific appointment slot can be cancelled through Reserve with Google.
	 * This field will override any service-level cancellation rules. (optional)
	 */
	last_online_cancellable_sec?: string | undefined
}

/**
 * A resource is used to disambiguate availability slots from one another when
 * different staff, room or party_size values are part of the service.
 * Multiple slots for the same service and time interval can co-exist when they
 * have different resources.
 */
export interface Resources {
	/**
	 * Optional ID for a staff member providing the service. This field identifies
	 * the staff member across all merchants, services, and availability records.
	 * It also needs to be stable over time to allow correlation with past
	 * bookings. (optional but required if staff_name is present)
	 */
	staff_id?: string | undefined
	/**
	 * Optional name of a staff member providing the service. This field will be
	 * displayed to users making a booking, and should be human-readable, as
	 * opposed to an opaque identifier. (optional but required if staff_id is
	 * present)
	 */
	staff_name?: string | undefined
	/**
	 * An optional ID for the room the service is located in. This field
	 * identifies the room across all merchants, services, and availability
	 * records. It also needs to be stable over time to allow correlation with
	 * past bookings. (optional but required if room_name is present)
	 */
	room_id?: string | undefined
	/**
	 * An optional name for the room the service is located in or experience of
	 * of the service. This field will be displayed to users making a booking,
	 * and should be human readable, as opposed to an opaque identifier.
	 * A room name should only be used for seating areas or prepaid experiences.
	 * Examples of room names include "Bar", "Patio", "Dining Room". Examples of
	 * dining experiences using room names include "Five-Course Tasting Menu",
	 * "Chef Omakase". It is strongly recommended that the default seating area
	 * does not have a room associated with it.
	 */
	room_name?: string | undefined
	/**
	 * Applicable only for Dining: The party size that can be accommodated
	 * during this time slot. A restaurant can be associated with multiple Slots
	 * for the same time, each specifying a different party_size, if for instance
	 * 2, 3, or 4 people can be seated with a reservation. (optional)
	 */
	party_size?: number | undefined
	/**
	 * Localized room description with a limit of 500 characters. If set,
	 * a default value must be provided, it is preferred to use the common
	 * languages for the merchant's locale.
	 */
	room_description?: Text | undefined
}

/** A payment the user may be charged as part of their reservation. */
export interface Prepayment {
	price_info?: PriceInfo | undefined
}

/** Container for price details. */
export interface PriceInfo {
	price?: Price | undefined
	/** The upper and/or lower bound */
	price_range?: PriceRange | undefined
	/** Defines how price or price range is applied (per person or fixed) */
	price_type?: PriceType | undefined
}

/**
 * Wrapper for a range of monetary amount treated as unbounded unless both
 * values are set. At least one of min_amount and max_amount is required.
 */
export interface PriceRange {
	/** Minimum amount. */
	min_price?: Price | undefined
	/** Maximum amount. Should always be > min_price. */
	max_price?: Price | undefined
}
